import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ar: {
    translation: {
      brand: "HAI",
      tagline: "منصة HAI للتداول الذكي ومكافآت التفاعل",
      heroDesc: "اشترِ وتداول عملة HAI داخليًا، اربح من الإعلانات والعجلة اليومية ونظام الإحالات، وتفاعل مع مجتمع المتداولين في مكان واحد",
      getStarted: "ابدأ الآن",
      learnMore: "اكتشف المزيد",
      signIn: "تسجيل الدخول",
      signUp: "إنشاء حساب",
      signOut: "تسجيل الخروج",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      fullName: "الاسم الكامل",
      continueWithGoogle: "المتابعة باستخدام Google",
      or: "أو",
      dashboard: "لوحة التحكم",
      wallet: "المحفظة",
      market: "السوق",
      ads: "الإعلانات",
      balance: "الرصيد",
      coinStrength: "قوة العملة",
      totalEarned: "إجمالي الأرباح",
      currentPrice: "السعر الحالي",
      buy: "شراء",
      sell: "بيع",
      amount: "الكمية",
      price: "السعر",
      watchAd: "مشاهدة الإعلان",
      earn: "اكسب",
      transactions: "المعاملات",
      features: "المميزات",
      f1Title: "تداول HAI داخلي",
      f1Desc: "اشترِ وبِع عملة HAI بسعر مباشر يتحدّث كل ثانية، مع صفقات Binary قصيرة المدى",
      f2Title: "مكافآت يومية",
      f2Desc: "أدر عجلة الحظ كل يوم واحصد مكافآت HAI مع مكافأة ترحيب عند التسجيل",
      f3Title: "إحالات ومكافآت",
      f3Desc: "ادعُ أصدقاءك عبر رابط الإحالة واحصل على مكافآت HAI لكل تسجيل جديد",
      f4Title: "إيداع وتحويل آمن",
      f4Desc: "اشحن رصيدك بالعملات الرقمية USDT وحوّل HAI لأي مستخدم عبر معرّف الدفع Pay ID",
      welcomeBonus: "مكافأة الترحيب",
      reward: "مكافأة",
      seconds: "ثانية",
      orders: "الأوامر",
      placeOrder: "تنفيذ الأمر",
      noOrders: "لا توجد أوامر",
      noTransactions: "لا توجد معاملات",
      adWatched: "تمت مشاهدة الإعلان",
      rewardEarned: "تم منحك {{amount}} HAI",
      insufficientBalance: "رصيد غير كافٍ",
      orderPlaced: "تم تنفيذ الأمر بنجاح",
      language: "اللغة",
      footer: "© 2026 HAI. جميع الحقوق محفوظة.",
      buyCoin: "شراء العملة",
      settings: "الإعدادات",
      walletSub: "رصيد عملة المنصة فقط",
      liveHaiPrice: "سعر HAI الحي",
      liveHaiPriceSub: "يتحرّك بصفقات المتداولين",

      // Common
      "common.loading": "جاري التحميل…",
      "common.save": "حفظ",
      "common.saving": "جاري الحفظ…",
      "common.cancel": "إلغاء",
      "common.confirm": "تأكيد",
      "common.back": "الرجوع",
      "common.copy": "نسخ",
      "common.copied": "تم النسخ",
      "common.copyFailed": "تعذّر النسخ",
      "common.search": "بحث",
      "common.delete": "حذف",
      "common.edit": "تعديل",
      "common.close": "إغلاق",
      "common.optional": "(اختياري)",
      "common.all": "الكل",
      "common.today": "اليوم",
      "common.last24h": "آخر 24 ساعة",
      "common.last7d": "آخر 7 أيام",
      "common.last30d": "آخر 30 يوم",
      "common.processing": "جاري المعالجة",
      "common.sec": "ث",
      "common.min": "د",
      "common.hour": "س",
      "common.day": "يوم",
      "common.unknown": "مجهول",
      "common.totalLabel": "الإجمالي",
      "common.amountLabel": "المبلغ",
      "common.timeLabel": "الوقت",

      // Auth (extra)
      "auth.refCode": "كود الإحالة (اختياري)",
      "auth.refHelper": "صديقك سيحصل على 10 HAI عند تسجيلك ✨",
      "auth.checkEmail": "تحقّق من بريدك لتأكيد الحساب",

      // BottomNav
      "nav.home": "الرئيسية",
      "nav.trade": "تداول",
      "nav.buy": "شراء",
      "nav.transfer": "تحويل",
      "nav.winners": "فائزون",
      "nav.rewards": "المكافآت",
      "nav.settings": "إعدادات",

      // Live price ticker
      "ticker.lastUpdate": "آخر تحديث",

      // Winners
      "winners.title": "سجل الفائزين (آخر 24 ساعة)",
      "winners.empty": "لا يوجد فائزون بعد. كن أول من يربح!",
      "winners.winsCount": "{{count}} فوز",

      // Daily wheel
      "wheel.title": "عجلة الحظ اليومية",
      "wheel.spinning": "جاري الدوران…",
      "wheel.spinNow": "🎰 لُف الآن (مجاني)",
      "wheel.comeBack": "العودة بعد {{h}}س {{m}}د",
      "wheel.footer": "دوران واحد كل 24 ساعة · جوائز من 0.5 إلى 50 HAI",
      "wheel.won": "🎉 ربحت {{reward}} HAI!",

      // Trading hub
      "trading.platform": "منصة التداول",
      "trading.modeChart": "الشارت والتداول",
      "trading.modeQuick": "شراء/بيع سريع",
      "trading.modeHistory": "سجل الصفقات",
      "trading.placeFromChart": "ضع صفقتك مباشرة من الشارت ↓",

      // Buy HAI panel
      "buyHai.title": "شراء HAI بـ USDT",
      "buyHai.secure": "دفع آمن — تأكيد تلقائي عبر الشبكة",
      "buyHai.history": "السجل",
      "buyHai.amountUsdt": "المبلغ بالـ USDT",
      "buyHai.fetchingPrice": "جاري جلب السعر…",
      "buyHai.livePrice": "السعر الحي للمنصة",
      "buyHai.warn": "⚠ يحتسب الرصيد حسب سعر HAI الحي عند تأكيد الدفع، وقد يختلف قليلاً عن الحساب الحالي.",
      "buyHai.goToPay": "الانتقال لصفحة الدفع الموحدة",
      "buyHai.unifiedNote": "تم توحيد الشراء: صفحة الإيداع هي المكان الوحيد لإنشاء عنوان دفع فريد وباركود مرتبط بحسابك.",

      // DM
      "dm.placeholder": "رسالة…",
      "dm.rejected": "رُفضت الرسالة",

      // Settings
      "settings.title": "إعدادات الحساب",
      "settings.adminPanel": "لوحة مدير النظام",
      "settings.profile": "الملف الشخصي",
      "settings.uploading": "...جاري الرفع",
      "settings.changeAvatar": "تغيير الصورة",
      "settings.avatarHint": "JPG/PNG/WEBP/GIF — حتى 5MB",
      "settings.maxSize5": "الحجم الأقصى 5MB",
      "settings.unsupportedImage": "نوع صورة غير مدعوم",
      "settings.unsupportedExt": "امتداد غير مسموح",
      "settings.imageUpdated": "تم تحديث الصورة",
      "settings.username": "الاسم المستعار (اختياري)",
      "settings.usernameHint": "سيظهر في المنشورات والتعليقات بدلاً من اسمك الكامل",
      "settings.privacyTitle": "الخصوصية",
      "settings.useAlias": "إظهار الاسم المستعار بدل الاسم الكامل",
      "settings.useAliasHint": "في المنشورات والتعليقات والرسائل",
      "settings.hideAvatar": "إخفاء صورة الملف الشخصي",
      "settings.hideAvatarHint": "ستُعرض صورة افتراضية للآخرين بدلاً من صورتك",
      "settings.hideCountry": "إخفاء موقعي (الدولة)",
      "settings.hideCountryHint": "لن يظهر بلدك في المنشورات والتعليقات",
      "settings.detect": "تحديد تلقائي",
      "settings.geoFailed": "تعذّر تحديد الموقع",
      "settings.country": "الدولة",
      "settings.countryPh": "تُكتشف تلقائياً",
      "settings.emailLabel": "الإيميل",
      "settings.saveChanges": "حفظ التغييرات",
      "settings.saved": "تم الحفظ",
      "settings.changePassword": "تغيير كلمة المرور",
      "settings.newPassword": "كلمة المرور الجديدة",
      "settings.confirmPassword": "تأكيد كلمة المرور",
      "settings.updatePassword": "تحديث كلمة المرور",
      "settings.minLen6": "6 أحرف على الأقل",
      "settings.passNotMatch": "الكلمتان غير متطابقتين",
      "settings.passUpdated": "تم تغيير كلمة المرور",
      "settings.accessibility": "إمكانية الوصول",
      "settings.reduceMotion": "تقليل الحركة",
      "settings.reduceMotionDesc": "يوقف دوران وتوهّج رمز العملة والتأثيرات المتحرّكة مع الحفاظ على الهوية البصرية الذهبية.",
      "settings.motionOff": "تم تقليل الحركة",
      "settings.motionOn": "تم تفعيل الحركة",
      "settings.sessions": "الجلسات",
      "settings.sessionsDesc": "سجّل خروجاً من جميع الأجهزة المرتبطة بحسابك.",
      "settings.signOutAll": "تسجيل الخروج من كل الأجهزة",

      // Deposit address admin
      "depAdmin.title": "عنوان إيداع USDT TRC20",
      "depAdmin.desc": "هذا العنوان يظهر للمستخدمين مع باركود QR لشراء HAI.",
      "depAdmin.address": "عنوان المحفظة (TRC20)",
      "depAdmin.memo": "مذكرة اختيارية",
      "depAdmin.memoPh": "(اختياري)",
      "depAdmin.saved": "تم حفظ عنوان الإيداع",

      // Admin
      "admin.checking": "جاري التحقق…",
      "admin.noPerm": "صلاحية غير كافية",
      "admin.noPermShort": "صلاحية مدير مطلوبة",
      "admin.return": "عودة",
      "admin.title": "لوحة المدير — HAI",
      "admin.adminPanel": "لوحة المدير",
      "admin.pinLayer": "طبقة الأمان الثانية",
      "admin.pinPromptEnter": "أدخل كلمة المرور الإضافية للدخول",
      "admin.pinPromptSetup": "أنشئ كلمة مرور إضافية (4 أحرف على الأقل) لحماية لوحة المدير",
      "admin.pinExtra": "كلمة المرور الإضافية",
      "admin.pinNew": "كلمة مرور جديدة",
      "admin.pinConfirm": "تأكيد كلمة المرور",
      "admin.pinOpen": "فتح اللوحة",
      "admin.pinSaveActivate": "حفظ وتفعيل",
      "admin.pinMin4": "4 أحرف على الأقل",
      "admin.pinMismatch": "الكلمتان غير متطابقتين",
      "admin.pinSet": "تم تعيين كلمة المرور الإضافية",
      "admin.pinWrong": "كلمة مرور غير صحيحة",
      "admin.statPrice": "سعر HAI",
      "admin.statUsers": "المستخدمون",
      "admin.statEvolutions": "دورات التطور",
      "admin.alertsTitle": "تنبيهات Webhook ({{count}})",
      "admin.openLog": "فتح السجل",
      "admin.markAllRead": "تعليم الكل كمقروء",
      "admin.usersMgmt": "إدارة المستخدمين",
      "admin.usersMgmtDesc": "حظر، أدوار، أرصدة، حذف",
      "admin.webhooksLog": "سجل NOWPayments Webhooks",
      "admin.webhooksLogDesc": "حالة كل معاملة: نجاح/فشل/مكرر مع التفاصيل الكاملة",
      "admin.auditLog": "سجل تدقيق الإجراءات",
      "admin.auditLogDesc": "كل تعديل رصيد، حظر، تغيير دور أو حذف مع المنفّذ والوقت",
      "admin.smartCoin": "العملة الذكية ذاتية التطور",
      "admin.smartCoinDesc": "تشغيل دورة تطور بالذكاء الاصطناعي — تحلل الأمان والسوق والأداء وتعدل سعر HAI تلقائياً",
      "admin.evolveNow": "تطوير الآن",
      "admin.thinking": "...يفكر",
      "admin.evolved": "العملة تطورت — السعر الجديد {{price}} USDT",
      "admin.evolutionLog": "سجل تطور الذكاء",
      "admin.noCycles": "لا توجد دورات بعد",
      "admin.security": "أمان",
      "admin.market": "سوق",
      "admin.performance": "أداء",

      // Admin Users
      "adminUsers.title": "إدارة المستخدمين",
      "adminUsers.searchPh": "بحث بالإيميل أو الاسم…",
      "adminUsers.fAll": "الكل ({{count}})",
      "adminUsers.fAdmin": "الأدمن",
      "adminUsers.fUser": "المستخدمون العاديون",
      "adminUsers.fBanned": "المحظورون",
      "adminUsers.empty": "لا يوجد مستخدمون",
      "adminUsers.banned": "محظور",
      "adminUsers.balance": "رصيد",
      "adminUsers.role": "دور",
      "adminUsers.unban": "فك الحظر",
      "adminUsers.ban": "حظر",
      "adminUsers.banReasonPrompt": "سبب الحظر؟",
      "adminUsers.banDone": "تم الحظر",
      "adminUsers.unbanDone": "تم رفع الحظر",
      "adminUsers.roleUpdated": "تم تحديث الدور",
      "adminUsers.adjustPrompt": "تعديل رصيد {{email}} (موجب للإضافة، سالب للخصم):",
      "adminUsers.balanceUpdated": "تم تعديل الرصيد",
      "adminUsers.deleteConfirm": "حذف نهائي للمستخدم {{email}}؟ لا يمكن التراجع.",
      "adminUsers.deleted": "تم الحذف",
      "adminUsers.changeRoleOf": "تغيير دور {{email}}",
      "adminUsers.reasonLabel": "السبب",

      // Audit log
      "audit.title": "سجل تدقيق المسؤولين",
      "audit.empty": "لا توجد إجراءات بعد",
      "audit.actor": "المنفّذ",
      "audit.target": "الهدف",
      "audit.actAdjust": "تعديل رصيد",
      "audit.actBan": "حظر مستخدم",
      "audit.actUnban": "رفع الحظر",
      "audit.actSetRole": "تغيير دور",
      "audit.actDelete": "حذف مستخدم",

      // Webhooks
      "wh.title": "سجل NOWPayments Webhooks",
      "wh.refresh": "تحديث",
      "wh.statTotal": "الإجمالي",
      "wh.statOk": "ناجح",
      "wh.statFail": "فشل",
      "wh.statDup": "مكرر",
      "wh.empty": "لم يصل أي webhook بعد.",
      "wh.sigOk": "توقيع صحيح",
      "wh.sigUnverified": "توقيع غير محقّق",
      "wh.details": "تفاصيل",
      "wh.detailsTitle": "تفاصيل الـ Webhook",
      "wh.sReceived": "مستلم",
      "wh.sProcessed": "تمت المعالجة",
      "wh.sCredited": "تم إضافة الرصيد",
      "wh.sDuplicate": "مكرر",
      "wh.sIgnored": "متجاهل",
      "wh.sInvalidSig": "توقيع غير صالح",
      "wh.sError": "خطأ",
      "wh.sFailed": "فشل",

      // Transfer page
      "tr.title": "تحويل HAI",
      "sup.title": "الدعم الفني",
      "sup.adminTitle": "تذاكر الدعم",
      "sup.adminDesc": "رسائل المستخدمين عن المشكلات",
      "sup.adminOnly": "مخصص للمدير فقط",
      "sup.back": "رجوع",
      "sup.heroTitle": "تواصل مباشر مع الإدارة",
      "sup.heroSub": "أرسل مشكلتك وسيتم الرد عليك في أقرب وقت",
      "sup.category": "نوع المشكلة",
      "sup.subject": "الموضوع",
      "sup.subjectPh": "ملخص قصير للمشكلة",
      "sup.message": "تفاصيل المشكلة",
      "sup.messagePh": "اشرح المشكلة بالتفصيل…",
      "sup.send": "إرسال إلى الإدارة",
      "sup.sent": "تم إرسال التذكرة بنجاح",
      "sup.subjectShort": "الموضوع قصير جدًا",
      "sup.messageShort": "الرسالة قصيرة جدًا",
      "sup.myTickets": "تذاكري",
      "sup.empty": "لا توجد تذاكر",
      "sup.adminReply": "رد الإدارة",
      "sup.filter": "تصفية",
      "sup.all": "الكل",
      "sup.replyPh": "اكتب ردك للمستخدم…",
      "sup.replyShort": "الرد قصير جدًا",
      "sup.replied": "تم إرسال الرد",
      "sup.replyAndResolve": "رد وإغلاق",
      "sup.markInProgress": "قيد المعالجة",
      "sup.close": "إغلاق",
      "sup.statusUpdated": "تم تحديث الحالة",
      "sup.cat.account": "الحساب",
      "sup.cat.deposit": "الإيداع",
      "sup.cat.transfer": "التحويل",
      "sup.cat.trade": "التداول",
      "sup.cat.bug": "خلل تقني",
      "sup.cat.security": "أمان",
      "sup.cat.other": "أخرى",
      "sup.status.open": "مفتوحة",
      "sup.status.in_progress": "قيد المعالجة",
      "sup.status.resolved": "تم الحل",
      "sup.status.closed": "مغلقة",
      "tr.back": "الرجوع",
      "tr.heroTitle": "إرسال HAI لمستخدم آخر",
      "tr.heroSub": "مؤمّن برمز التداول — حد يومي 2,000,000 HAI",
      "tr.available": "رصيدك المتاح",
      "tr.dailyLimit": "الحد اليومي للتحويل",
      "tr.dailyUsed": "المُستخدم خلال 24س",
      "tr.dailyRemaining": "المتبقي خلال 24س",
      "tr.unlimited": "غير محدود (مدير)",
      "tr.myPayId": "معرّف الإيداع الخاص بك",
      "tr.stable": "ثابت ولا يتغيّر",
      "tr.copyId": "نسخ المعرّف",
      "tr.scanToSend": "امسح الرمز لإرسال HAI إلى محفظتك",
      "tr.shareDesc": "شارك هذا المعرّف أو رمز QR مع أي مستخدم على المنصة ليرسل لك عملة HAI مباشرةً إلى محفظتك.",
      "tr.needPin": "يجب ضبط رمز PIN للتداول قبل التحويل.",
      "tr.goSettings": "الانتقال للإعدادات",
      "tr.recipientLabel": "المستلم (معرّف الإيداع فقط — HAI-XXXXXXXX)",
      "tr.search": "بحث",
      "tr.scanQr": "مسح QR",
      "tr.scanQrTitle": "مسح رمز QR",
      "tr.scanHint": "امسح رمز QR لمعرّف الإيداع — ستظهر خطوة تحقق قبل التحويل.",
      "tr.payIdMatch": "تطابق ناجح: المعرّف يخص هذا المستخدم بالضبط",
      "tr.payIdMismatch": "المعرّف لا يطابق المستلم — تحقّق قبل المتابعة",
      "tr.user": "مستخدم",
      "tr.cantSelf": "لا يمكنك التحويل إلى نفسك",
      "tr.confirmCheck": "أؤكد بصريًا أن هذا هو المستلم الصحيح، وأن التحويل نهائي وغير قابل للاسترداد.",
      "tr.amountLabel": "المبلغ (HAI)",
      "tr.all": "الكل",
      "tr.pinLabel": "رمز PIN للتداول",
      "tr.sending": "جاري التحويل…",
      "tr.sendNow": "إرسال الآن",
      "tr.finalNote": "عمليات التحويل نهائية ولا يمكن التراجع عنها. تأكد من بيانات المستلم قبل التأكيد.",
      "tr.success": "تم التحويل بنجاح ✓",
      "tr.successAmount": "تم تحويل {{amount}} HAI بنجاح",
      "tr.hideReceipt": "إخفاء",
      "tr.amount": "المبلغ",
      "tr.recipient": "المستلم",
      "tr.txId": "رقم المعاملة",
      "tr.toHome": "إلى الرئيسية",
      "tr.newTransfer": "تحويل جديد",
      "tr.copied": "تم النسخ",
      "tr.cameraUnsupported": "جهازك لا يدعم الوصول إلى الكاميرا",
      "tr.cameraDenied": "تم رفض إذن الكاميرا. فعّله من إعدادات المتصفح/الهاتف ثم أعد المحاولة.",
      "tr.cameraNotFound": "لم يتم العثور على كاميرا في هذا الجهاز.",
      "tr.cameraFailed": "تعذّر الوصول إلى الكاميرا",
      "tr.notFound": "لم يتم العثور على المستخدم. تأكد من المعرّف (مثال: HAI-XXXXXXXX) أو البريد/اسم المستخدم.",
      "tr.selfId": "هذا معرّفك أنت — لا يمكن التحويل إلى نفس الحساب",
      "tr.invalidPay": "الرمز ليس معرّف إيداع HAI صالح",
      "tr.notFoundPay": "لم يتم العثور على مستخدم بهذا المعرّف",
      "tr.payMismatchSec": "معرّف غير مطابق — مرفوض لأسباب الأمان",
      "tr.cantOpenCamera": "تعذّر فتح الكاميرا",
      "tr.confirmedRecipient": "تم تأكيد المستلم بصريًا ✓",
      "tr.pickRecipient": "اختر المستلم أولاً",
      "tr.confirmFirst": "يرجى تأكيد المستلم بصريًا قبل التحويل",
      "tr.invalidAmount": "ادخل مبلغ صحيح",
      "tr.lowBalance": "الرصيد غير كافٍ",
      "tr.enterPin": "أدخل رمز PIN",
      "tr.permTitle": "إذن استخدام الكاميرا",
      "tr.permDesc": "لتتمكّن من مسح رمز QR لمعرّف الإيداع، يحتاج التطبيق إلى إذن الوصول إلى كاميرا جهازك. لن يتم تسجيل أو رفع أي صورة — تُستخدم الكاميرا فقط لقراءة الرمز محليًا في متصفحك.",
      "tr.permWarn": "سيظهر لك الآن طلب رسمي من المتصفح/الهاتف. اضغط <b>السماح</b> للمتابعة. إذا رفضت سابقًا، فعّل الإذن يدويًا من إعدادات الموقع.",
      "tr.cancel": "إلغاء",
      "tr.requesting": "جاري الطلب…",
      "tr.allowCamera": "السماح للكاميرا",
      "tr.scanQrHint": "وجّه الكاميرا نحو رمز QR لمعرّف الإيداع HAI-XXXXXXXX",
      "tr.verifyTitle": "تحقّق من المستلم",
      "tr.verifyDesc": "تم اكتشاف معرّف إيداع من رمز QR. تأكّد من البيانات قبل المتابعة.",
      "tr.recipientName": "اسم المستلم",
      "tr.amountToSend": "المبلغ المراد تحويله (HAI)",
      "tr.currentBalance": "رصيدك الحالي",
      "tr.amountSent": "المبلغ المرسل",
      "tr.willReceive": "سيستلم المستلم",
      "tr.expectedAfter": "رصيدك المتوقع بعد التحويل",
      "tr.lowBalanceShort": "الرصيد غير كافٍ لهذا المبلغ.",
      "tr.confirmRecipient": "تأكيد المستلم",
      "tr.hideReceiptAria": "إخفاء الإيصال",

      // Deposits page
      "dep.title": "سجل الشحنات",
      "dep.history": "السجل",
      "dep.back": "الرجوع",
      "dep.heroTitle": "شراء HAI بـ USDT",
      "dep.heroSub": "دفع آمن — تأكيد تلقائي عبر الشبكة",
      "dep.linked": "مرتبط بحسابك",
      "dep.amountUsdt": "المبلغ بالـ USDT",
      "dep.livePrice": "السعر الحي للمنصة: 1 HAI = {{price}} USDT (1 USDT = {{inv}} HAI)",
      "dep.fetchingPrice": "جاري جلب السعر…",
      "dep.warnPrice": "⚠ يحتسب الرصيد حسب سعر HAI الحي عند تأكيد الدفع، وقد يختلف قليلاً عن الحساب الحالي.",
      "dep.lockingPrice": "جاري تثبيت السعر…",
      "dep.relock": "إعادة تثبيت السعر وإنشاء فاتورة جديدة",
      "dep.lock": "تثبيت السعر وإنشاء فاتورة دفع",
      "dep.invoiceLine": "فاتورتك الخاصة #{{id}} — الباركود أدناه مرتبط بحسابك فقط.",
      "dep.priceAtCalc": "السعر وقت الحساب",
      "dep.time": "الوقت",
      "dep.priceNow": "السعر الحي الآن",
      "dep.expectedHai": "HAI المتوقّع عند الدفع",
      "dep.priceChanged": "تغيّر السعر بنسبة {{pct}}% — الفرق {{diff}} HAI مقارنة بالحساب",
      "dep.sendExactly": "أرسل بالضبط",
      "dep.onNetwork": "على شبكة <strong>{{net}} (BEP20)</strong> فقط",
      "dep.qrAria": "QR عنوان الدفع",
      "dep.payAddress": "عنوان الدفع",
      "dep.copyAmount": "نسخ المبلغ المطلوب",
      "dep.autoCredit": "سيتم اعتماد HAI تلقائياً في محفظتك بعد تأكيد الشبكة (1–5 دقائق عادةً).",
      "dep.noInvoice": "اضغط على «تثبيت السعر وفتح أداة الدفع» أعلاه لإنشاء فاتورة دفع فريدة مرتبطة بحسابك.",
      "dep.notesTitle": "ملاحظات مهمة:",
      "dep.note1": "اختر <strong>USDT</strong> على شبكة <strong>BSC / BEP20</strong> في الأداة أعلاه.",
      "dep.note2": "أرسل المبلغ المطلوب بالضبط إلى عنوان الدفع الظاهر.",
      "dep.note3": "سيتم إضافة HAI إلى محفظتك تلقائياً بعد تأكيد المعاملة على الشبكة.",
      "dep.loading": "جاري التحميل…",
      "dep.empty": "لا توجد شحنات بعد.",
      "dep.via": "عبر {{cur}}",
      "dep.haiAdded": "HAI المضاف",
      "dep.pending": "(معلّق)",
      "dep.amountRequired": "المبلغ المطلوب",
      "dep.opNumber": "رقم العملية: {{id}}",
      "dep.invoiceCreated": "تم إنشاء الفاتورة — أرسل الدفعة للعنوان الظاهر بالأسفل",
      "dep.invoiceFailed": "تعذر إنشاء الفاتورة",
      "dep.invalidApi": "مفتاح NOWPayments مرفوض. استخدم مفتاح API إنتاج فعّال من حساب NOWPayments، وليس مفتاح Sandbox.",
      "dep.copied": "تم النسخ",
      "dep.sWaiting": "بانتظار الدفع",
      "dep.sConfirming": "جاري التأكيد",
      "dep.sConfirmed": "مؤكّد",
      "dep.sFinished": "مكتمل",
      "dep.sSending": "جاري الإرسال",
      "dep.sPartial": "دفع جزئي",
      "dep.sFailed": "فشل",
      "dep.sRefunded": "مُسترد",
      "dep.sExpired": "منتهي",

      // Deposit History
      "dh.title": "سجل الإيداعات",
      "dh.back": "الرجوع",
      "dh.pending": "بانتظار",
      "dh.success": "مكتمل",
      "dh.failed": "فشل",
      "dh.viewAll": "عرض جميع الإيداعات",
      "dh.loading": "جاري التحميل…",
      "dh.empty": "لا توجد إيداعات لعرضها.",
      "dh.lastUpdate": "آخر تحديث",
      "dh.webhookEvents": "أحداث Webhook ({{count}})",
      "dh.noEvents": "لم يتم استلام أحداث webhook لهذه الفاتورة بعد.",
      "dh.status": "الحالة",
      "dh.signature": "التوقيع",
      "dh.sigValid": "✓ صالح",
      "dh.sigInvalid": "✗ غير صالح",
      "dh.sPaid": "مدفوع",
      "dh.pReceived": "تم الاستلام",
      "dh.pCredited": "تم الإيداع",
      "dh.pIgnored": "حالة وسيطة",
      "dh.pDuplicate": "مكرر",
      "dh.pInvalidSig": "توقيع غير صالح",
      "dh.pError": "خطأ",
      "dh.pFailed": "فشل",

      // Deposit stages
      "stg.waiting": "بانتظار الدفع",
      "stg.confirming": "جاري التأكيد على الشبكة",
      "stg.sending": "إيداع HAI في المحفظة",
      "stg.finished": "مكتمل",
      "stg.etaWaiting": "حتى تُرسل الدفعة",
      "stg.etaConfirming": "≈ 1–5 دقائق",
      "stg.etaSending": "≈ بضع ثوان",
      "stg.exWaiting": "أنشأنا الفاتورة وننتظر استلام الدفعة في عنوان USDT (BSC). أرسل المبلغ بالضبط الظاهر في أداة الدفع.",
      "stg.exPartial": "تم استلام جزء من المبلغ فقط. أكمل إرسال الفرق ليتم تأكيد الدفعة.",
      "stg.exConfirming": "تم استلام المعاملة على شبكة BSC وننتظر التأكيدات اللازمة. عادة 1–5 دقائق.",
      "stg.exConfirmed": "تم تأكيد المعاملة على الشبكة. جاري إيداع HAI في محفظتك الآن.",
      "stg.exSending": "جاري إضافة HAI إلى محفظتك — لحظات وتنتهي العملية.",
      "stg.exFinished": "اكتمل الإيداع بنجاح وأُضيفت HAI إلى رصيدك.",
      "stg.exPaid": "تم الدفع وتأكيده — اكتمل الإيداع.",
      "stg.exFailed": "فشلت العملية. لم يُخصم أي رصيد — يمكنك المحاولة مجدداً.",
      "stg.exRefunded": "تم استرداد المبلغ إلى محفظتك المرسلة.",
      "stg.exExpired": "انتهت صلاحية الفاتورة قبل استلام الدفعة. أنشئ فاتورة جديدة.",
      "stg.exUnknown": "حالة غير معروفة.",
      "stg.failed": "فشل الإيداع",
      "stg.done": "تم الإيداع بنجاح",
      "stg.processing": "جاري المعالجة",
      "stg.lessMin": "أقل من دقيقة",
      "stg.minShort": "د",
      "stg.hourShort": "س",
      "stg.since": "منذ {{t}}",
      "stg.nextStage": "المرحلة التالية {{eta}}",
      "bp.dur5": "⚡5ث",
      "bp.dur10": "⚡10ث",
      "bp.dur30": "30 ث",
      "bp.dur60": "1 د",
      "bp.dur180": "3 د",
      "bp.dur300": "5 د",
      "bp.dur900": "15 د",
      "bp.dur1800": "30 د",
      "bp.dur3600": "1 س",
      "bp.win": "فوز",
      "bp.loss": "خسارة",
      "bp.draw": "تعادل",
      "bp.tradeAmt": "صفقة {{amt}} HAI · إجمالي العائد {{payout}} HAI",
      "bp.entryExit": "الدخول {{entry}} → الخروج {{exit}}",
      "bp.refund": "تعادل {{dir}} استرداد {{amt}} HAI",
      "bp.enterAmt": "ادخل مبلغًا صحيحًا",
      "bp.enterPin": "ادخل PIN التداول",
      "bp.cantOpen": "تعذر فتح الصفقة",
      "bp.invalidPin": "PIN غير صحيح",
      "bp.setPinFirst": "اضبط PIN التداول أولاً",
      "bp.lowBal": "رصيدك غير كافٍ لفتح هذه الصفقة",
      "bp.dailyLimit": "تجاوزت الحد اليومي للتداول (100,000 HAI)",
      "bp.unsupDur": "مدة الصفقة غير مدعومة",
      "bp.badDir": "اتجاه غير صالح",
      "bp.banned": "الحساب موقوف",
      "bp.opened": "تم فتح صفقة {{dir}} بمبلغ {{amt}} HAI",
      "bp.up": "صعود ▲",
      "bp.down": "هبوط ▼",
      "bp.pinLen": "PIN يجب أن يكون 4-12 خانة",
      "bp.pinMismatch": "PIN غير متطابق",
      "bp.pinSet": "تم ضبط PIN التداول",
      "bp.title": "تداول عملة HAI · صعود / هبوط",
      "bp.soundOff": "إيقاف الصوت",
      "bp.soundOn": "تفعيل الصوت",
      "bp.pinOn": "PIN مفعّل",
      "bp.pinOff": "PIN غير مضبوط",
      "bp.upLabel": "UP · صعود",
      "bp.downLabel": "DOWN · هبوط",
      "bp.duration": "المدة",
      "bp.amount": "المبلغ (HAI)",
      "bp.streak": "🔥 سلسلة الفوز:",
      "bp.best": "أفضل: {{n}}",
      "bp.nextWin": "الفوز القادم ×{{x}}",
      "bp.payRate": "عائد الفوز:",
      "bp.totalWin": "الإجمالي عند الفوز:",
      "bp.onLoss": "عند الخسارة:",
      "bp.openTrade": "فتح صفقة {{dir}}",
      "bp.wins": "فوز",
      "bp.losses": "خسارة",
      "bp.winRate": "نسبة الفوز",
      "bp.activeTrades": "صفقات نشطة ({{n}})",
      "bp.secShort": "ث",
      "bp.lastResults": "آخر النتائج",
      "bp.tie": "تعادل",
      "bp.setPinTitle": "اضبط PIN التداول",
      "bp.confirmTrade": "تأكيد الصفقة",
      "bp.pinHint": "لحماية حسابك يجب ضبط PIN خاص بالتداول (4-12 خانة) سيُطلب عند كل صفقة.",
      "bp.pinConfirmHint": "ادخل PIN التداول لتأكيد فتح صفقة <span class=\"{{cls}}\">{{dir}}</span> بمبلغ <span class=\"font-bold\">{{stake}} HAI</span>.",
      "bp.confirmPin": "تأكيد PIN",
      "bp.forgotPin": "نسيت رمز التداول؟ إعادة ضبطه الآن",
      "bp.cancel": "إلغاء",
      "bp.setOpen": "ضبط & فتح صفقة",
      "bp.confirm": "تأكيد",
      "tm.enterQty": "ادخل كمية صحيحة",
      "tm.orderPlacedSide": "تم وضع أمر {{side}}",
      "tm.buy": "شراء",
      "tm.sell": "بيع",
      "tm.cancelled": "تم إلغاء الأمر",
      "tm.title": "سوق HAI الداخلي",
      "tm.high": "أعلى:",
      "tm.low": "أدنى:",
      "tm.impact24": "تأثير 24س",
      "tm.orders": "أوامر",
      "tm.yourBal": "رصيدك",
      "tm.book": "دفتر الأوامر",
      "tm.bid": "شراء (Bid)",
      "tm.ask": "بيع (Ask)",
      "tm.noOrders": "لا توجد أوامر",
      "tm.bidPrice": "مؤشر الطلب (HAI)",
      "tm.askPrice": "مؤشر العرض (HAI)",
      "tm.market": "سعر السوق",
      "tm.qty": "الكمية (HAI)",
      "tm.available": "المتاح:",
      "tm.bidImpact": "تأثير الطلب:",
      "tm.askImpact": "تأثير العرض:",
      "tm.executing": "جاري التنفيذ...",
      "tm.buyHai": "شراء HAI",
      "tm.sellHai": "بيع HAI",
      "tm.myOpen": "أوامري المفتوحة ({{n}})",
      "ac.officialPrice": "السعر الرسمي {{p}}",
      "ac.title": "شموع HAI · السعر الرسمي {{p}}",
      "ac.candles": "شموع",
      "ac.line": "خط",
      "ac.area": "مساحة",
      "ac.zoomIn": "تكبير الشموع",
      "ac.zoomOut": "تصغير الشموع",
      "ac.fit": "ملء العرض",
      "ac.taller": "ارتفاع أكبر",
      "ac.shorter": "ارتفاع أقل",
      "ac.noData": "لا توجد بيانات سعرية كافية بعد.",
      "ai.greet": "أهلاً! أنا مساعد HAI الذكي. اسألني عن المنصة، التداول، أو حلّل أداءك.",
      "ai.rate": "تم تجاوز الحد، حاول لاحقاً",
      "ai.noCredits": "نفدت أرصدة المساعد",
      "ai.connFail": "تعذّر الاتصال، حاول مرة أخرى.",
      "ai.aria": "مساعد HAI الذكي",
      "ai.title": "مساعد HAI",
      "ai.sub": "مدعوم بالذكاء الاصطناعي",
      "ai.placeholder": "اكتب سؤالك...",
      "ls.ar": "العربية",
      "fd.writeOrAttach": "اكتب شيئاً أو ارفق وسائط",
      "fd.unsupType": "نوع ملف غير مدعوم",
      "fd.unsupExt": "امتداد غير مسموح",
      "fd.rejected": "رُفض المنشور: {{r}}",
      "fd.inappropriate": "محتوى غير لائق",
      "fd.publishedPinned": "تم النشر ومثبّت في الأعلى",
      "fd.published": "تم النشر",
      "fd.confirmDelete": "حذف المنشور؟",
      "fd.deleteFailed": "تعذر الحذف: {{m}}",
      "fd.deleted": "تم الحذف",
      "fd.commentRejected": "رُفض التعليق: {{r}}",
      "fd.unsupMedia": "نوع غير مدعوم. الصور: JPG/PNG/WEBP/GIF — الفيديو: MP4/WEBM/MOV",
      "fd.maxSize": "الحجم الأقصى {{mb}}MB",
      "fd.placeholder": "ماذا يدور في ذهنك؟",
      "fd.preview": "معاينة",
      "fd.image": "صورة",
      "fd.video": "فيديو",
      "fd.posting": "...جاري النشر",
      "fd.publish": "نشر",
      "fd.dropHint": "يمكنك سحب وإفلات الملف هنا · الحد الأقصى: صور 10MB / فيديو 50MB",
      "fd.all": "الكل",
      "fd.country": "بلدي",
      "fd.following": "أتابعهم",
      "fd.empty": "لا توجد منشورات بعد — كن أول من ينشر!",
      "fd.user": "مستخدم",
      "fd.adminPin": "منشور المدير",
      "fd.followed": "متابَع",
      "fd.follow": "متابعة",
      "fd.dm": "رسالة خاصة",
      "fd.commentPh": "اكتب تعليقاً…",
      "th.market_buy": "شراء سوق",
      "th.market_sell_lock": "بيع سوق",
      "th.order_refund": "استرداد أمر",
      "th.buy": "شراء",
      "th.sell": "بيع",
      "th.ad_reward": "مكافأة إعلان",
      "th.reward": "مكافأة",
      "th.crypto_deposit": "إيداع USDT",
      "th.admin_grant": "منحة إدارية",
      "th.admin_adjust": "تعديل إداري",
      "th.bonus": "مكافأة",
      "th.withdrawal": "سحب",
      "th.deposit": "إيداع",
      "th.purchase": "شراء",
      "th.sale": "بيع",
      "th.transfer": "تحويل",
      "th.loadMore": "تحميل المزيد...",
      "th.endList": "— نهاية القائمة —",
      "th.title": "سجل التداول والمحفظة",
      "th.balance": "الرصيد",
      "th.totalEarn": "إجمالي الأرباح",
      "th.coinPower": "قوة العملة: {{n}}",
      "th.fees": "الرسوم",
      "th.feesCount": "{{n}} عملية",
      "th.tabsOrders": "الطلبات ({{n}})",
      "th.tabsTrades": "الصفقات ({{n}})",
      "th.tabsFees": "الرسوم ({{n}})",
      "th.noOrders": "لا توجد طلبات",
      "th.statusOpen": "مفتوح",
      "th.statusFilled": "منفّذ",
      "th.statusCancelled": "ملغي",
      "th.noTrades": "لا توجد صفقات",
      "th.noFees": "لا توجد رسوم",
      "th.feeDefault": "رسوم",
      "rf.registered": "تم تسجيل الإحالة",
      "rf.copied": "{{label}} نُسخ ✓",
      "rf.copyFail": "تعذّر النسخ",
      "rf.shareText": "انضم إلى HAI واحصل على عملاتك! استخدم رابطي: {{link}}",
      "rf.text": "النص",
      "rf.loading": "جاري التحميل…",
      "rf.title": "ادعُ أصدقاءك واربح",
      "rf.perFriend": "+10 HAI لكل صديق ينضم",
      "rf.invited": "مدعوّون",
      "rf.totalEarn": "إجمالي الأرباح",
      "rf.code": "كودك",
      "rf.linkLabel": "رابط الإحالة الخاص بك",
      "rf.link": "الرابط",
      "rf.copyLink": "نسخ الرابط",
      "rf.share": "مشاركة",
      "rf.askCode": "هل دعاك صديق؟ أدخل كوده (مرة واحدة فقط)",
      "rf.confirm": "تأكيد",
      "rf.alreadyRegistered": "✓ مسجّل بكود إحالة",
      "rf.recent": "آخر المدعوّين",
      "rf.shareNote": "شارك رابطك أعلاه — كل صديق ينضم يضيف لك 10 HAI فورًا 🎁",
      "lq.base": "قاعدة السيولة الثابتة",
      "lq.deposits": "إيداعات شراء العملة (USDT)",
      "lq.wallets": "أرصدة المستخدمين",
      "lq.openBuy": "أوامر الشراء المفتوحة",
      "lq.bets24": "رهانات آخر 24س",
      "lq.refRewards": "مكافآت الإحالة",
      "lq.totalSub": "السيولة الكلية للمنصة",
      "lq.coinPrice": "سعر العملة 0.0100 USDT",
      "lq.sources": "مصادر السيولة:",
      "lq.note": "تزداد السيولة تلقائيًا مع كل عملية شراء عملة بـUSDT، ومع كل أمر سوق جديد، وكل مكافأة إحالة أو رهان مفتوح.",
      "pf.invalidSym": "الرمز غير صالح: {{r}}",
      "pf.savedLocal": "تم حفظ التفضيل المحلي · {{s}}",
      "pf.savedAll": "تم حفظ إعدادات السعر · {{s}}",
      "pf.title": "مغذّي السعر المباشر",
      "pf.connected": "متصل",
      "pf.disconnected": "غير متصل",
      "pf.source": "المصدر: Binance (مجاني، بدون مفتاح API)",
      "pf.symLabel": "رمز التداول",
      "pf.willUse": "سيتم استخدام: ",
      "pf.checking": "جاري التحقق…",
      "pf.valid": "صالح · ",
      "pf.examples": "أمثلة: BTC، btc/usdt، eth-usdt، SOLUSDT… سيتم تحويلها تلقائيًا.",
      "pf.enable": "تفعيل المغذّي",
      "pf.enableHint": "عند الإيقاف يتوقف إدراج الأسعار في قاعدة البيانات.",
      "pf.saveAll": "حفظ الإعدادات (عام)",
      "pf.saveLocal": "حفظ التفضيل المحلي",
      "pf.adminOnly": "الإعداد العام للرمز يُحدَّد من قبل المشرفين فقط. يمكنك حفظ تفضيل عرض محلي.",
      "ct.last24": "آخر 24 ساعة",
      "ct.last7": "آخر 7 أيام",
      "ct.last30": "آخر 30 يوم",
      "ct.title": "إحصاءات زر شراء HAI بـ USDT",
      "ct.loading": "جاري التحميل…",
      "ct.clicks": "نقرات ({{l}})",
      "ct.unique": "مستخدمون فريدون",
      "ct.created": "فواتير أُنشئت",
      "ct.paid": "فواتير مدفوعة",
      "ct.clickToInv": "نقرة → فاتورة",
      "ct.clickToInvHint": "معدل التحويل من النقر إلى إنشاء فاتورة",
      "ct.invToPay": "فاتورة → دفع",
      "ct.invToPayHint": "معدل إكمال الدفع للفواتير المُنشأة",
      "ct.totalClicks": "إجمالي النقرات",
      "ct.totalClicksHint": "منذ بداية التتبع",
      "ct.byHourDay": "CTR ومعدل الدفع حسب {{u}}",
      "ct.hour": "الساعة",
      "ct.day": "اليوم",
      "ct.ctrLine": "CTR (نقرة→فاتورة)",
      "ct.payRateLine": "معدل الدفع",
    },
  },
  en: {
    translation: {
      brand: "HAI",
      tagline: "The HAI platform for smart trading and engagement rewards",
      heroDesc: "Buy and trade the in-app HAI token, earn from ads, the daily wheel and referrals, and connect with a live trader community — all in one place",
      getStarted: "Get Started",
      learnMore: "Learn More",
      signIn: "Sign In",
      signUp: "Sign Up",
      signOut: "Sign Out",
      email: "Email",
      password: "Password",
      fullName: "Full Name",
      continueWithGoogle: "Continue with Google",
      or: "OR",
      dashboard: "Dashboard",
      wallet: "Wallet",
      market: "Market",
      ads: "Ads",
      balance: "Balance",
      coinStrength: "Coin Strength",
      totalEarned: "Total Earned",
      currentPrice: "Current Price",
      buy: "Buy",
      sell: "Sell",
      amount: "Amount",
      price: "Price",
      watchAd: "Watch Ad",
      earn: "Earn",
      transactions: "Transactions",
      features: "Features",
      f1Title: "In-app HAI Trading",
      f1Desc: "Buy and sell HAI at a live price that updates every second, plus short-term binary trades",
      f2Title: "Daily Rewards",
      f2Desc: "Spin the daily wheel to collect HAI, plus a welcome bonus when you sign up",
      f3Title: "Referrals & Rewards",
      f3Desc: "Invite friends with your referral link and earn HAI for every new sign-up",
      f4Title: "Secure Deposit & Transfer",
      f4Desc: "Top up with USDT crypto and send HAI to any user via their Pay ID",
      welcomeBonus: "Welcome Bonus",
      reward: "Reward",
      seconds: "seconds",
      orders: "Orders",
      placeOrder: "Place Order",
      noOrders: "No orders",
      noTransactions: "No transactions",
      adWatched: "Ad watched",
      rewardEarned: "You earned {{amount}} HAI",
      insufficientBalance: "Insufficient balance",
      orderPlaced: "Order placed successfully",
      language: "Language",
      footer: "© 2026 HAI. All rights reserved.",
      buyCoin: "Buy Coin",
      settings: "Settings",
      walletSub: "Platform coin balance only",
      liveHaiPrice: "Live HAI Price",
      liveHaiPriceSub: "Driven by trader activity",

      "common.loading": "Loading…",
      "common.save": "Save",
      "common.saving": "Saving…",
      "common.cancel": "Cancel",
      "common.confirm": "Confirm",
      "common.back": "Back",
      "common.copy": "Copy",
      "common.copied": "Copied",
      "common.copyFailed": "Copy failed",
      "common.search": "Search",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.close": "Close",
      "common.optional": "(optional)",
      "common.all": "All",
      "common.today": "Today",
      "common.last24h": "Last 24h",
      "common.last7d": "Last 7 days",
      "common.last30d": "Last 30 days",
      "common.processing": "Processing",
      "common.sec": "s",
      "common.min": "m",
      "common.hour": "h",
      "common.day": "day",
      "common.unknown": "Unknown",
      "common.totalLabel": "Total",
      "common.amountLabel": "Amount",
      "common.timeLabel": "Time",

      "auth.refCode": "Referral code (optional)",
      "auth.refHelper": "Your friend gets 10 HAI when you sign up ✨",
      "auth.checkEmail": "Check your email to confirm",

      "nav.home": "Home",
      "nav.trade": "Trade",
      "nav.buy": "Buy",
      "nav.transfer": "Transfer",
      "nav.winners": "Winners",
      "nav.rewards": "Rewards",
      "nav.settings": "Settings",

      "ticker.lastUpdate": "Last update",

      "winners.title": "Winners log (last 24h)",
      "winners.empty": "No winners yet. Be the first to win!",
      "winners.winsCount": "{{count}} wins",

      "wheel.title": "Daily Spin Wheel",
      "wheel.spinning": "Spinning…",
      "wheel.spinNow": "🎰 Spin now (free)",
      "wheel.comeBack": "Come back in {{h}}h {{m}}m",
      "wheel.footer": "One spin every 24h · Prizes from 0.5 to 50 HAI",
      "wheel.won": "🎉 You won {{reward}} HAI!",

      "trading.platform": "Trading Platform",
      "trading.modeChart": "Chart & Trade",
      "trading.modeQuick": "Quick Buy/Sell",
      "trading.modeHistory": "Trade History",
      "trading.placeFromChart": "Place your trade right from the chart ↓",

      "buyHai.title": "Buy HAI with USDT",
      "buyHai.secure": "Secure payment — auto-confirmed on-chain",
      "buyHai.history": "History",
      "buyHai.amountUsdt": "Amount in USDT",
      "buyHai.fetchingPrice": "Fetching price…",
      "buyHai.livePrice": "Live platform price",
      "buyHai.warn": "⚠ Credit is calculated using the live HAI price at confirmation, may differ slightly from the current estimate.",
      "buyHai.goToPay": "Go to unified payment page",
      "buyHai.unifiedNote": "Buying is unified: the deposits page is the only place to generate a unique payment address and QR linked to your account.",

      "dm.placeholder": "Message…",
      "dm.rejected": "Message rejected",

      "settings.title": "Account Settings",
      "settings.adminPanel": "Admin panel",
      "settings.profile": "Profile",
      "settings.uploading": "Uploading…",
      "settings.changeAvatar": "Change avatar",
      "settings.avatarHint": "JPG/PNG/WEBP/GIF — up to 5MB",
      "settings.maxSize5": "Max size 5MB",
      "settings.unsupportedImage": "Unsupported image type",
      "settings.unsupportedExt": "Unsupported extension",
      "settings.imageUpdated": "Avatar updated",
      "settings.username": "Nickname (optional)",
      "settings.usernameHint": "Shown on posts and comments instead of your full name",
      "settings.privacyTitle": "Privacy",
      "settings.useAlias": "Show nickname instead of full name",
      "settings.useAliasHint": "Applies to posts, comments and messages",
      "settings.hideAvatar": "Hide profile picture",
      "settings.hideAvatarHint": "Others will see a default avatar instead of your photo",
      "settings.hideCountry": "Hide my location (country)",
      "settings.hideCountryHint": "Your country will not appear on posts and comments",
      "settings.detect": "Detect",
      "settings.geoFailed": "Could not detect location",
      "settings.country": "Country",
      "settings.countryPh": "Auto-detected",
      "settings.emailLabel": "Email",
      "settings.saveChanges": "Save changes",
      "settings.saved": "Saved",
      "settings.changePassword": "Change password",
      "settings.newPassword": "New password",
      "settings.confirmPassword": "Confirm password",
      "settings.updatePassword": "Update password",
      "settings.minLen6": "At least 6 characters",
      "settings.passNotMatch": "Passwords do not match",
      "settings.passUpdated": "Password updated",
      "settings.accessibility": "Accessibility",
      "settings.reduceMotion": "Reduce motion",
      "settings.reduceMotionDesc": "Disables coin spin/glow and animated effects while keeping the gold visual identity.",
      "settings.motionOff": "Motion reduced",
      "settings.motionOn": "Motion enabled",
      "settings.sessions": "Sessions",
      "settings.sessionsDesc": "Sign out from all devices linked to your account.",
      "settings.signOutAll": "Sign out from all devices",

      "depAdmin.title": "USDT TRC20 deposit address",
      "depAdmin.desc": "This address is shown to users with a QR code to buy HAI.",
      "depAdmin.address": "Wallet address (TRC20)",
      "depAdmin.memo": "Optional memo",
      "depAdmin.memoPh": "(optional)",
      "depAdmin.saved": "Deposit address saved",

      "admin.checking": "Verifying…",
      "admin.noPerm": "Insufficient permissions",
      "admin.noPermShort": "Admin permission required",
      "admin.return": "Back",
      "admin.title": "Admin Panel — HAI",
      "admin.adminPanel": "Admin Panel",
      "admin.pinLayer": "Second Security Layer",
      "admin.pinPromptEnter": "Enter the additional password to continue",
      "admin.pinPromptSetup": "Create an additional password (min 4 chars) to protect the admin panel",
      "admin.pinExtra": "Additional password",
      "admin.pinNew": "New password",
      "admin.pinConfirm": "Confirm password",
      "admin.pinOpen": "Unlock panel",
      "admin.pinSaveActivate": "Save & activate",
      "admin.pinMin4": "At least 4 characters",
      "admin.pinMismatch": "Passwords do not match",
      "admin.pinSet": "Additional password set",
      "admin.pinWrong": "Wrong password",
      "admin.statPrice": "HAI Price",
      "admin.statUsers": "Users",
      "admin.statEvolutions": "Evolution cycles",
      "admin.alertsTitle": "Webhook alerts ({{count}})",
      "admin.openLog": "Open log",
      "admin.markAllRead": "Mark all as read",
      "admin.usersMgmt": "Users management",
      "admin.usersMgmtDesc": "Bans, roles, balances, deletion",
      "admin.webhooksLog": "NOWPayments Webhooks log",
      "admin.webhooksLogDesc": "Per-transaction status: success/fail/duplicate with full details",
      "admin.auditLog": "Actions audit log",
      "admin.auditLogDesc": "Every balance change, ban, role change or deletion with actor and time",
      "admin.smartCoin": "Self-evolving smart coin",
      "admin.smartCoinDesc": "Run an AI evolution cycle — analyzes security, market and performance and adjusts HAI price automatically",
      "admin.evolveNow": "Evolve now",
      "admin.thinking": "Thinking…",
      "admin.evolved": "Coin evolved — new price {{price}} USDT",
      "admin.evolutionLog": "Intelligence evolution log",
      "admin.noCycles": "No cycles yet",
      "admin.security": "Security",
      "admin.market": "Market",
      "admin.performance": "Performance",

      "adminUsers.title": "Users management",
      "adminUsers.searchPh": "Search by email or name…",
      "adminUsers.fAll": "All ({{count}})",
      "adminUsers.fAdmin": "Admins",
      "adminUsers.fUser": "Regular users",
      "adminUsers.fBanned": "Banned",
      "adminUsers.empty": "No users",
      "adminUsers.banned": "banned",
      "adminUsers.balance": "Balance",
      "adminUsers.role": "Role",
      "adminUsers.unban": "Unban",
      "adminUsers.ban": "Ban",
      "adminUsers.banReasonPrompt": "Ban reason?",
      "adminUsers.banDone": "User banned",
      "adminUsers.unbanDone": "User unbanned",
      "adminUsers.roleUpdated": "Role updated",
      "adminUsers.adjustPrompt": "Adjust balance for {{email}} (positive to add, negative to deduct):",
      "adminUsers.balanceUpdated": "Balance updated",
      "adminUsers.deleteConfirm": "Permanently delete user {{email}}? This cannot be undone.",
      "adminUsers.deleted": "Deleted",
      "adminUsers.changeRoleOf": "Change role for {{email}}",
      "adminUsers.reasonLabel": "Reason",

      "audit.title": "Admin audit log",
      "audit.empty": "No actions yet",
      "audit.actor": "Actor",
      "audit.target": "Target",
      "audit.actAdjust": "Adjust balance",
      "audit.actBan": "Ban user",
      "audit.actUnban": "Unban",
      "audit.actSetRole": "Change role",
      "audit.actDelete": "Delete user",

      "wh.title": "NOWPayments Webhooks log",
      "wh.refresh": "Refresh",
      "wh.statTotal": "Total",
      "wh.statOk": "Successful",
      "wh.statFail": "Failed",
      "wh.statDup": "Duplicate",
      "wh.empty": "No webhooks received yet.",
      "wh.sigOk": "Valid signature",
      "wh.sigUnverified": "Unverified signature",
      "wh.details": "Details",
      "wh.detailsTitle": "Webhook details",
      "wh.sReceived": "Received",
      "wh.sProcessed": "Processed",
      "wh.sCredited": "Credited",
      "wh.sDuplicate": "Duplicate",
      "wh.sIgnored": "Ignored",
      "wh.sInvalidSig": "Invalid signature",
      "wh.sError": "Error",
      "wh.sFailed": "Failed",

      // Transfer page
      "tr.title": "Transfer HAI",
      "sup.title": "Support",
      "sup.adminTitle": "Support Tickets",
      "sup.adminDesc": "Issue reports from users",
      "sup.adminOnly": "Admins only",
      "sup.back": "Back",
      "sup.heroTitle": "Contact admin directly",
      "sup.heroSub": "Send your issue and we'll reply soon",
      "sup.category": "Issue type",
      "sup.subject": "Subject",
      "sup.subjectPh": "Short summary",
      "sup.message": "Details",
      "sup.messagePh": "Describe the issue in detail…",
      "sup.send": "Send to admin",
      "sup.sent": "Ticket sent successfully",
      "sup.subjectShort": "Subject too short",
      "sup.messageShort": "Message too short",
      "sup.myTickets": "My tickets",
      "sup.empty": "No tickets",
      "sup.adminReply": "Admin reply",
      "sup.filter": "Filter",
      "sup.all": "All",
      "sup.replyPh": "Write your reply…",
      "sup.replyShort": "Reply too short",
      "sup.replied": "Reply sent",
      "sup.replyAndResolve": "Reply & resolve",
      "sup.markInProgress": "In progress",
      "sup.close": "Close",
      "sup.statusUpdated": "Status updated",
      "sup.cat.account": "Account",
      "sup.cat.deposit": "Deposit",
      "sup.cat.transfer": "Transfer",
      "sup.cat.trade": "Trading",
      "sup.cat.bug": "Bug",
      "sup.cat.security": "Security",
      "sup.cat.other": "Other",
      "sup.status.open": "Open",
      "sup.status.in_progress": "In progress",
      "sup.status.resolved": "Resolved",
      "sup.status.closed": "Closed",
      "tr.back": "Back",
      "tr.heroTitle": "Send HAI to another user",
      "tr.heroSub": "Secured with trade PIN — daily limit 2,000,000 HAI",
      "tr.available": "Available balance",
      "tr.dailyLimit": "Daily transfer limit",
      "tr.dailyUsed": "Used in last 24h",
      "tr.dailyRemaining": "Remaining in 24h",
      "tr.unlimited": "Unlimited (admin)",
      "tr.myPayId": "Your deposit ID",
      "tr.stable": "Permanent — never changes",
      "tr.copyId": "Copy ID",
      "tr.scanToSend": "Scan the code to send HAI to your wallet",
      "tr.shareDesc": "Share this ID or QR code with any platform user so they can send HAI directly to your wallet.",
      "tr.needPin": "You must set a trade PIN before transferring.",
      "tr.goSettings": "Go to settings",
      "tr.recipientLabel": "Recipient (Pay ID only — HAI-XXXXXXXX)",
      "tr.search": "Search",
      "tr.scanQr": "Scan QR",
      "tr.scanQrTitle": "Scan QR code",
      "tr.scanHint": "Scan the deposit ID QR — a verification step appears before transfer.",
      "tr.payIdMatch": "Match: this ID belongs exactly to this user",
      "tr.payIdMismatch": "ID does not match the recipient — verify before continuing",
      "tr.user": "User",
      "tr.cantSelf": "You cannot transfer to yourself",
      "tr.confirmCheck": "I visually confirm this is the correct recipient and that the transfer is final and non-refundable.",
      "tr.amountLabel": "Amount (HAI)",
      "tr.all": "Max",
      "tr.pinLabel": "Trade PIN",
      "tr.sending": "Transferring…",
      "tr.sendNow": "Send now",
      "tr.finalNote": "Transfers are final and irreversible. Verify recipient details before confirming.",
      "tr.success": "Transfer successful ✓",
      "tr.successAmount": "Successfully transferred {{amount}} HAI",
      "tr.hideReceipt": "Hide",
      "tr.amount": "Amount",
      "tr.recipient": "Recipient",
      "tr.txId": "Transaction ID",
      "tr.toHome": "Home",
      "tr.newTransfer": "New transfer",
      "tr.copied": "Copied",
      "tr.cameraUnsupported": "Your device does not support camera access",
      "tr.cameraDenied": "Camera permission denied. Enable it from the browser/phone settings and try again.",
      "tr.cameraNotFound": "No camera found on this device.",
      "tr.cameraFailed": "Could not access the camera",
      "tr.notFound": "User not found. Verify the ID (e.g. HAI-XXXXXXXX), email or username.",
      "tr.selfId": "This is your own ID — cannot transfer to your own account",
      "tr.invalidPay": "The code is not a valid HAI deposit ID",
      "tr.notFoundPay": "No user found with this ID",
      "tr.payMismatchSec": "ID mismatch — rejected for security reasons",
      "tr.cantOpenCamera": "Could not open the camera",
      "tr.confirmedRecipient": "Recipient visually confirmed ✓",
      "tr.pickRecipient": "Select a recipient first",
      "tr.confirmFirst": "Please visually confirm the recipient before transferring",
      "tr.invalidAmount": "Enter a valid amount",
      "tr.lowBalance": "Insufficient balance",
      "tr.enterPin": "Enter your PIN",
      "tr.permTitle": "Camera permission",
      "tr.permDesc": "To scan the deposit ID QR, the app needs access to your device camera. No image is recorded or uploaded — the camera is used only to read the code locally in your browser.",
      "tr.permWarn": "An official browser/phone prompt will appear. Press <b>Allow</b> to continue. If you previously denied it, enable it manually from site settings.",
      "tr.cancel": "Cancel",
      "tr.requesting": "Requesting…",
      "tr.allowCamera": "Allow camera",
      "tr.scanQrHint": "Point the camera at the deposit ID QR HAI-XXXXXXXX",
      "tr.verifyTitle": "Verify recipient",
      "tr.verifyDesc": "A deposit ID was detected from the QR code. Confirm the details before continuing.",
      "tr.recipientName": "Recipient name",
      "tr.amountToSend": "Amount to transfer (HAI)",
      "tr.currentBalance": "Your current balance",
      "tr.amountSent": "Amount sent",
      "tr.willReceive": "Recipient will receive",
      "tr.expectedAfter": "Your expected balance after",
      "tr.lowBalanceShort": "Insufficient balance for this amount.",
      "tr.confirmRecipient": "Confirm recipient",
      "tr.hideReceiptAria": "Hide receipt",

      // Deposits page
      "dep.title": "Deposits",
      "dep.history": "History",
      "dep.back": "Back",
      "dep.heroTitle": "Buy HAI with USDT",
      "dep.heroSub": "Secure payment — auto-confirmed on-chain",
      "dep.linked": "Linked to your account",
      "dep.amountUsdt": "Amount in USDT",
      "dep.livePrice": "Live platform price: 1 HAI = {{price}} USDT (1 USDT = {{inv}} HAI)",
      "dep.fetchingPrice": "Fetching price…",
      "dep.warnPrice": "⚠ Balance is credited at the live HAI price at the moment of payment confirmation, which may differ slightly from the current calculation.",
      "dep.lockingPrice": "Locking price…",
      "dep.relock": "Re-lock price and create a new invoice",
      "dep.lock": "Lock price and create payment invoice",
      "dep.invoiceLine": "Your private invoice #{{id}} — the QR below is linked to your account only.",
      "dep.priceAtCalc": "Price at calculation",
      "dep.time": "Time",
      "dep.priceNow": "Live price now",
      "dep.expectedHai": "Expected HAI at payment",
      "dep.priceChanged": "Price changed by {{pct}}% — difference {{diff}} HAI vs calculation",
      "dep.sendExactly": "Send exactly",
      "dep.onNetwork": "on the <strong>{{net}} (BEP20)</strong> network only",
      "dep.qrAria": "Payment address QR",
      "dep.payAddress": "Payment address",
      "dep.copyAmount": "Copy required amount",
      "dep.autoCredit": "HAI will be credited to your wallet automatically after network confirmation (usually 1–5 minutes).",
      "dep.noInvoice": "Press \"Lock price and open the payment tool\" above to generate a unique payment invoice linked to your account.",
      "dep.notesTitle": "Important notes:",
      "dep.note1": "Pick <strong>USDT</strong> on the <strong>BSC / BEP20</strong> network in the tool above.",
      "dep.note2": "Send the exact required amount to the displayed payment address.",
      "dep.note3": "HAI is credited to your wallet automatically after the on-chain confirmation.",
      "dep.loading": "Loading…",
      "dep.empty": "No deposits yet.",
      "dep.via": "via {{cur}}",
      "dep.haiAdded": "HAI credited",
      "dep.pending": "(pending)",
      "dep.amountRequired": "Required amount",
      "dep.opNumber": "Operation ID: {{id}}",
      "dep.invoiceCreated": "Invoice created — send the payment to the address shown below",
      "dep.invoiceFailed": "Could not create invoice",
      "dep.invalidApi": "NOWPayments key rejected. Use a valid production API key from a NOWPayments account, not a Sandbox key.",
      "dep.copied": "Copied",
      "dep.sWaiting": "Waiting for payment",
      "dep.sConfirming": "Confirming",
      "dep.sConfirmed": "Confirmed",
      "dep.sFinished": "Completed",
      "dep.sSending": "Sending",
      "dep.sPartial": "Partially paid",
      "dep.sFailed": "Failed",
      "dep.sRefunded": "Refunded",
      "dep.sExpired": "Expired",

      // Deposit History
      "dh.title": "Deposit history",
      "dh.back": "Back",
      "dh.pending": "Pending",
      "dh.success": "Completed",
      "dh.failed": "Failed",
      "dh.viewAll": "Show all deposits",
      "dh.loading": "Loading…",
      "dh.empty": "No deposits to display.",
      "dh.lastUpdate": "Last update",
      "dh.webhookEvents": "Webhook events ({{count}})",
      "dh.noEvents": "No webhook events received for this invoice yet.",
      "dh.status": "Status",
      "dh.signature": "Signature",
      "dh.sigValid": "✓ valid",
      "dh.sigInvalid": "✗ invalid",
      "dh.sPaid": "Paid",
      "dh.pReceived": "Received",
      "dh.pCredited": "Credited",
      "dh.pIgnored": "Intermediate",
      "dh.pDuplicate": "Duplicate",
      "dh.pInvalidSig": "Invalid signature",
      "dh.pError": "Error",
      "dh.pFailed": "Failed",

      // Deposit stages
      "stg.waiting": "Awaiting payment",
      "stg.confirming": "Confirming on-chain",
      "stg.sending": "Crediting HAI to wallet",
      "stg.finished": "Completed",
      "stg.etaWaiting": "Until payment is sent",
      "stg.etaConfirming": "≈ 1–5 minutes",
      "stg.etaSending": "≈ a few seconds",
      "stg.exWaiting": "We created the invoice and are waiting for payment to the USDT (BSC) address. Send exactly the amount shown in the payment tool.",
      "stg.exPartial": "Only part of the amount was received. Send the remaining difference to confirm payment.",
      "stg.exConfirming": "Transaction received on the BSC network and waiting for required confirmations. Usually 1–5 minutes.",
      "stg.exConfirmed": "Transaction confirmed on-chain. Crediting HAI to your wallet now.",
      "stg.exSending": "Adding HAI to your wallet — finishing in moments.",
      "stg.exFinished": "Deposit completed successfully and HAI added to your balance.",
      "stg.exPaid": "Payment received and confirmed — deposit complete.",
      "stg.exFailed": "Operation failed. No balance was deducted — you can try again.",
      "stg.exRefunded": "The amount was refunded to your sending wallet.",
      "stg.exExpired": "The invoice expired before payment was received. Create a new invoice.",
      "stg.exUnknown": "Unknown status.",
      "stg.failed": "Deposit failed",
      "stg.done": "Deposit completed",
      "stg.processing": "Processing",
      "stg.lessMin": "less than a minute",
      "stg.minShort": "m",
      "stg.hourShort": "h",
      "stg.since": "{{t}} ago",
      "stg.nextStage": "Next stage in {{eta}}",
      "bp.dur5": "⚡5s",
      "bp.dur10": "⚡10s",
      "bp.dur30": "30s",
      "bp.dur60": "1m",
      "bp.dur180": "3m",
      "bp.dur300": "5m",
      "bp.dur900": "15m",
      "bp.dur1800": "30m",
      "bp.dur3600": "1h",
      "bp.win": "Win",
      "bp.loss": "Loss",
      "bp.draw": "Draw",
      "bp.tradeAmt": "Trade {{amt}} HAI · total payout {{payout}} HAI",
      "bp.entryExit": "Entry {{entry}} → Exit {{exit}}",
      "bp.refund": "Draw {{dir}} refunded {{amt}} HAI",
      "bp.enterAmt": "Enter a valid amount",
      "bp.enterPin": "Enter trading PIN",
      "bp.cantOpen": "Could not open the trade",
      "bp.invalidPin": "Wrong PIN",
      "bp.setPinFirst": "Set the trading PIN first",
      "bp.lowBal": "Insufficient balance for this trade",
      "bp.dailyLimit": "Daily trading limit exceeded (100,000 HAI)",
      "bp.unsupDur": "Unsupported duration",
      "bp.badDir": "Invalid direction",
      "bp.banned": "Account banned",
      "bp.opened": "Opened {{dir}} trade for {{amt}} HAI",
      "bp.up": "UP ▲",
      "bp.down": "DOWN ▼",
      "bp.pinLen": "PIN must be 4-12 digits",
      "bp.pinMismatch": "PIN does not match",
      "bp.pinSet": "Trading PIN set",
      "bp.title": "Trade HAI · Up / Down",
      "bp.soundOff": "Mute",
      "bp.soundOn": "Unmute",
      "bp.pinOn": "PIN active",
      "bp.pinOff": "PIN not set",
      "bp.upLabel": "UP",
      "bp.downLabel": "DOWN",
      "bp.duration": "Duration",
      "bp.amount": "Amount (HAI)",
      "bp.streak": "🔥 Winning streak:",
      "bp.best": "Best: {{n}}",
      "bp.nextWin": "Next win ×{{x}}",
      "bp.payRate": "Win payout:",
      "bp.totalWin": "Total on win:",
      "bp.onLoss": "On loss:",
      "bp.openTrade": "Open {{dir}} trade",
      "bp.wins": "Wins",
      "bp.losses": "Losses",
      "bp.winRate": "Win rate",
      "bp.activeTrades": "Active trades ({{n}})",
      "bp.secShort": "s",
      "bp.lastResults": "Latest results",
      "bp.tie": "Tie",
      "bp.setPinTitle": "Set trading PIN",
      "bp.confirmTrade": "Confirm trade",
      "bp.pinHint": "To protect your account, set a trading PIN (4-12 digits). It will be requested for every trade.",
      "bp.pinConfirmHint": "Enter the trading PIN to confirm a <span class=\"{{cls}}\">{{dir}}</span> trade of <span class=\"font-bold\">{{stake}} HAI</span>.",
      "bp.confirmPin": "Confirm PIN",
      "bp.forgotPin": "Forgot trading PIN? Reset it now",
      "bp.cancel": "Cancel",
      "bp.setOpen": "Set & open trade",
      "bp.confirm": "Confirm",
      "tm.enterQty": "Enter a valid quantity",
      "tm.orderPlacedSide": "{{side}} order placed",
      "tm.buy": "Buy",
      "tm.sell": "Sell",
      "tm.cancelled": "Order cancelled",
      "tm.title": "Internal HAI market",
      "tm.high": "High:",
      "tm.low": "Low:",
      "tm.impact24": "24h impact",
      "tm.orders": "Orders",
      "tm.yourBal": "Your balance",
      "tm.book": "Order book",
      "tm.bid": "Buy (Bid)",
      "tm.ask": "Sell (Ask)",
      "tm.noOrders": "No orders",
      "tm.bidPrice": "Bid price (HAI)",
      "tm.askPrice": "Ask price (HAI)",
      "tm.market": "Market price",
      "tm.qty": "Quantity (HAI)",
      "tm.available": "Available:",
      "tm.bidImpact": "Bid impact:",
      "tm.askImpact": "Ask impact:",
      "tm.executing": "Executing...",
      "tm.buyHai": "Buy HAI",
      "tm.sellHai": "Sell HAI",
      "tm.myOpen": "My open orders ({{n}})",
      "ac.officialPrice": "Official price {{p}}",
      "ac.title": "HAI candles · official price {{p}}",
      "ac.candles": "Candles",
      "ac.line": "Line",
      "ac.area": "Area",
      "ac.zoomIn": "Zoom in",
      "ac.zoomOut": "Zoom out",
      "ac.fit": "Fit",
      "ac.taller": "Taller",
      "ac.shorter": "Shorter",
      "ac.noData": "Not enough price data yet.",
      "ai.greet": "Hi! I'm the HAI AI assistant. Ask me about the platform, trading, or to analyse your performance.",
      "ai.rate": "Rate limited, try again later",
      "ai.noCredits": "Assistant credits exhausted",
      "ai.connFail": "Connection failed, please try again.",
      "ai.aria": "HAI AI assistant",
      "ai.title": "HAI Assistant",
      "ai.sub": "Powered by AI",
      "ai.placeholder": "Type your question...",
      "ls.ar": "العربية",
      "fd.writeOrAttach": "Write something or attach media",
      "fd.unsupType": "Unsupported file type",
      "fd.unsupExt": "Extension not allowed",
      "fd.rejected": "Post rejected: {{r}}",
      "fd.inappropriate": "Inappropriate content",
      "fd.publishedPinned": "Published and pinned",
      "fd.published": "Published",
      "fd.confirmDelete": "Delete post?",
      "fd.deleteFailed": "Delete failed: {{m}}",
      "fd.deleted": "Deleted",
      "fd.commentRejected": "Comment rejected: {{r}}",
      "fd.unsupMedia": "Unsupported type. Images: JPG/PNG/WEBP/GIF — Video: MP4/WEBM/MOV",
      "fd.maxSize": "Max size {{mb}}MB",
      "fd.placeholder": "What's on your mind?",
      "fd.preview": "Preview",
      "fd.image": "Image",
      "fd.video": "Video",
      "fd.posting": "Posting...",
      "fd.publish": "Publish",
      "fd.dropHint": "You can drag-drop files here · Max: 10MB image / 50MB video",
      "fd.all": "All",
      "fd.country": "My country",
      "fd.following": "Following",
      "fd.empty": "No posts yet — be the first!",
      "fd.user": "User",
      "fd.adminPin": "Admin post",
      "fd.followed": "Following",
      "fd.follow": "Follow",
      "fd.dm": "Direct message",
      "fd.commentPh": "Write a comment…",
      "th.market_buy": "Market buy",
      "th.market_sell_lock": "Market sell",
      "th.order_refund": "Order refund",
      "th.buy": "Buy",
      "th.sell": "Sell",
      "th.ad_reward": "Ad reward",
      "th.reward": "Reward",
      "th.crypto_deposit": "USDT deposit",
      "th.admin_grant": "Admin grant",
      "th.admin_adjust": "Admin adjustment",
      "th.bonus": "Bonus",
      "th.withdrawal": "Withdrawal",
      "th.deposit": "Deposit",
      "th.purchase": "Purchase",
      "th.sale": "Sale",
      "th.transfer": "Transfer",
      "th.loadMore": "Load more...",
      "th.endList": "— end of list —",
      "th.title": "Trading & wallet history",
      "th.balance": "Balance",
      "th.totalEarn": "Total earnings",
      "th.coinPower": "Coin strength: {{n}}",
      "th.fees": "Fees",
      "th.feesCount": "{{n}} ops",
      "th.tabsOrders": "Orders ({{n}})",
      "th.tabsTrades": "Trades ({{n}})",
      "th.tabsFees": "Fees ({{n}})",
      "th.noOrders": "No orders",
      "th.statusOpen": "Open",
      "th.statusFilled": "Filled",
      "th.statusCancelled": "Cancelled",
      "th.noTrades": "No trades",
      "th.noFees": "No fees",
      "th.feeDefault": "Fee",
      "rf.registered": "Referral registered",
      "rf.copied": "{{label}} copied ✓",
      "rf.copyFail": "Copy failed",
      "rf.shareText": "Join HAI and get your coins! Use my link: {{link}}",
      "rf.text": "Text",
      "rf.loading": "Loading…",
      "rf.title": "Invite friends & earn",
      "rf.perFriend": "+10 HAI per friend who joins",
      "rf.invited": "Invited",
      "rf.totalEarn": "Total earnings",
      "rf.code": "Your code",
      "rf.linkLabel": "Your referral link",
      "rf.link": "Link",
      "rf.copyLink": "Copy link",
      "rf.share": "Share",
      "rf.askCode": "Did a friend invite you? Enter their code (once)",
      "rf.confirm": "Confirm",
      "rf.alreadyRegistered": "✓ Registered with referral code",
      "rf.recent": "Recent invitees",
      "rf.shareNote": "Share your link above — every friend instantly adds 10 HAI 🎁",
      "lq.base": "Fixed liquidity base",
      "lq.deposits": "Coin purchase deposits (USDT)",
      "lq.wallets": "User balances",
      "lq.openBuy": "Open buy orders",
      "lq.bets24": "Last 24h bets",
      "lq.refRewards": "Referral rewards",
      "lq.totalSub": "Total platform liquidity",
      "lq.coinPrice": "Coin price 0.0100 USDT",
      "lq.sources": "Liquidity sources:",
      "lq.note": "Liquidity grows automatically with every USDT coin purchase, every new market order, and every referral reward or open bet.",
      "pf.invalidSym": "Invalid symbol: {{r}}",
      "pf.savedLocal": "Local preference saved · {{s}}",
      "pf.savedAll": "Price settings saved · {{s}}",
      "pf.title": "Live price feed",
      "pf.connected": "Connected",
      "pf.disconnected": "Disconnected",
      "pf.source": "Source: Binance (free, no API key)",
      "pf.symLabel": "Trading symbol",
      "pf.willUse": "Will use: ",
      "pf.checking": "Checking…",
      "pf.valid": "Valid · ",
      "pf.examples": "Examples: BTC, btc/usdt, eth-usdt, SOLUSDT… auto-converted.",
      "pf.enable": "Enable feed",
      "pf.enableHint": "When off, price ingestion into the database stops.",
      "pf.saveAll": "Save settings (global)",
      "pf.saveLocal": "Save local preference",
      "pf.adminOnly": "The global symbol is set by admins only. You can save a local display preference.",
      "ct.last24": "Last 24 hours",
      "ct.last7": "Last 7 days",
      "ct.last30": "Last 30 days",
      "ct.title": "Buy-HAI-with-USDT button stats",
      "ct.loading": "Loading…",
      "ct.clicks": "Clicks ({{l}})",
      "ct.unique": "Unique users",
      "ct.created": "Invoices created",
      "ct.paid": "Invoices paid",
      "ct.clickToInv": "Click → invoice",
      "ct.clickToInvHint": "Conversion rate from click to invoice creation",
      "ct.invToPay": "Invoice → payment",
      "ct.invToPayHint": "Payment completion rate for created invoices",
      "ct.totalClicks": "Total clicks",
      "ct.totalClicksHint": "Since tracking started",
      "ct.byHourDay": "CTR and payment rate by {{u}}",
      "ct.hour": "hour",
      "ct.day": "day",
      "ct.ctrLine": "CTR (click→invoice)",
      "ct.payRateLine": "Payment rate",
    },
  },
  zh: {
    translation: {
      brand: "HAI",
      tagline: "HAI 智能交易与互动奖励平台",
      heroDesc: "在应用内买卖 HAI 代币，通过广告、每日转盘和推荐获得奖励，并与交易者社区互动 —— 一站式体验",
      getStarted: "立即开始",
      learnMore: "了解更多",
      signIn: "登录",
      signUp: "注册",
      signOut: "退出",
      email: "电子邮件",
      password: "密码",
      fullName: "全名",
      continueWithGoogle: "使用Google继续",
      or: "或",
      dashboard: "仪表板",
      wallet: "钱包",
      market: "市场",
      ads: "广告",
      balance: "余额",
      coinStrength: "货币强度",
      totalEarned: "总收益",
      currentPrice: "当前价格",
      buy: "买入",
      sell: "卖出",
      amount: "数量",
      price: "价格",
      watchAd: "观看广告",
      earn: "赚取",
      transactions: "交易",
      features: "特点",
      f1Title: "应用内 HAI 交易",
      f1Desc: "按每秒更新的实时价格买卖 HAI，并支持短期二元期权交易",
      f2Title: "每日奖励",
      f2Desc: "每天旋转幸运转盘领取 HAI，注册即享欢迎奖励",
      f3Title: "推荐与奖励",
      f3Desc: "通过推荐链接邀请好友，每次新注册都可获得 HAI",
      f4Title: "安全充值与转账",
      f4Desc: "使用 USDT 加密货币充值，通过 Pay ID 向任何用户发送 HAI",
      welcomeBonus: "欢迎奖励",
      reward: "奖励",
      seconds: "秒",
      orders: "订单",
      placeOrder: "下单",
      noOrders: "暂无订单",
      noTransactions: "暂无交易",
      adWatched: "广告已观看",
      rewardEarned: "您获得了 {{amount}} HAI",
      insufficientBalance: "余额不足",
      orderPlaced: "订单成功下达",
      language: "语言",
      footer: "© 2026 HAI。版权所有。",
      buyCoin: "购买代币",
      settings: "设置",
      walletSub: "仅平台代币余额",
      liveHaiPrice: "HAI 实时价格",
      liveHaiPriceSub: "由交易者活动驱动",

      "common.loading": "加载中…",
      "common.save": "保存",
      "common.saving": "保存中…",
      "common.cancel": "取消",
      "common.confirm": "确认",
      "common.back": "返回",
      "common.copy": "复制",
      "common.copied": "已复制",
      "common.copyFailed": "复制失败",
      "common.search": "搜索",
      "common.delete": "删除",
      "common.edit": "编辑",
      "common.close": "关闭",
      "common.optional": "（可选）",
      "common.all": "全部",
      "common.today": "今天",
      "common.last24h": "最近 24 小时",
      "common.last7d": "最近 7 天",
      "common.last30d": "最近 30 天",
      "common.processing": "处理中",
      "common.sec": "秒",
      "common.min": "分",
      "common.hour": "小时",
      "common.day": "天",
      "common.unknown": "未知",
      "common.totalLabel": "总计",
      "common.amountLabel": "金额",
      "common.timeLabel": "时间",

      "auth.refCode": "推荐码（可选）",
      "auth.refHelper": "您的朋友在您注册时将获得 10 HAI ✨",
      "auth.checkEmail": "请查收邮件以确认账户",

      "nav.home": "首页",
      "nav.trade": "交易",
      "nav.buy": "购买",
      "nav.transfer": "转账",
      "nav.winners": "排行榜",
      "nav.rewards": "奖励",
      "nav.settings": "设置",

      "ticker.lastUpdate": "最后更新",

      "winners.title": "获奖记录（最近 24 小时）",
      "winners.empty": "暂无获奖者，成为第一位赢家！",
      "winners.winsCount": "{{count}} 次获奖",

      "wheel.title": "每日幸运转盘",
      "wheel.spinning": "旋转中…",
      "wheel.spinNow": "🎰 立即旋转（免费）",
      "wheel.comeBack": "{{h}}小时{{m}}分后再来",
      "wheel.footer": "每 24 小时旋转一次 · 奖励 0.5 至 50 HAI",
      "wheel.won": "🎉 您赢得了 {{reward}} HAI！",

      "trading.platform": "交易平台",
      "trading.modeChart": "图表与交易",
      "trading.modeQuick": "快速买卖",
      "trading.modeHistory": "交易记录",
      "trading.placeFromChart": "直接从图表下单 ↓",

      "buyHai.title": "用 USDT 购买 HAI",
      "buyHai.secure": "安全支付 — 链上自动确认",
      "buyHai.history": "记录",
      "buyHai.amountUsdt": "USDT 金额",
      "buyHai.fetchingPrice": "正在获取价格…",
      "buyHai.livePrice": "平台实时价格",
      "buyHai.warn": "⚠ 余额按确认时的实时 HAI 价格计算，可能与当前估算略有差异。",
      "buyHai.goToPay": "前往统一支付页面",
      "buyHai.unifiedNote": "购买已统一：充值页面是生成与您账户绑定的唯一支付地址和二维码的唯一入口。",

      "dm.placeholder": "消息…",
      "dm.rejected": "消息被拒绝",

      "settings.title": "账户设置",
      "settings.adminPanel": "管理面板",
      "settings.profile": "个人资料",
      "settings.uploading": "上传中…",
      "settings.changeAvatar": "更换头像",
      "settings.avatarHint": "JPG/PNG/WEBP/GIF — 最大 5MB",
      "settings.maxSize5": "最大 5MB",
      "settings.unsupportedImage": "不支持的图片类型",
      "settings.unsupportedExt": "不支持的扩展名",
      "settings.imageUpdated": "头像已更新",
      "settings.username": "昵称（可选）",
      "settings.usernameHint": "将显示在帖子和评论中，代替您的全名",
      "settings.privacyTitle": "隐私",
      "settings.useAlias": "显示昵称代替全名",
      "settings.useAliasHint": "适用于帖子、评论和消息",
      "settings.hideAvatar": "隐藏头像",
      "settings.hideAvatarHint": "其他人将看到默认头像，而不是您的照片",
      "settings.hideCountry": "隐藏我的位置（国家）",
      "settings.hideCountryHint": "您的国家不会显示在帖子和评论中",
      "settings.detect": "自动检测",
      "settings.geoFailed": "无法检测位置",
      "settings.country": "国家/地区",
      "settings.countryPh": "自动检测",
      "settings.emailLabel": "电子邮件",
      "settings.saveChanges": "保存更改",
      "settings.saved": "已保存",
      "settings.changePassword": "修改密码",
      "settings.newPassword": "新密码",
      "settings.confirmPassword": "确认密码",
      "settings.updatePassword": "更新密码",
      "settings.minLen6": "至少 6 个字符",
      "settings.passNotMatch": "两次密码不一致",
      "settings.passUpdated": "密码已更新",
      "settings.accessibility": "无障碍",
      "settings.reduceMotion": "减少动画",
      "settings.reduceMotionDesc": "关闭代币的旋转和发光效果及动效，同时保留金色视觉风格。",
      "settings.motionOff": "已减少动画",
      "settings.motionOn": "已启用动画",
      "settings.sessions": "会话",
      "settings.sessionsDesc": "登出所有与您账户关联的设备。",
      "settings.signOutAll": "登出所有设备",

      "depAdmin.title": "USDT TRC20 充值地址",
      "depAdmin.desc": "此地址将与二维码一同显示给用户用于购买 HAI。",
      "depAdmin.address": "钱包地址 (TRC20)",
      "depAdmin.memo": "可选备注",
      "depAdmin.memoPh": "（可选）",
      "depAdmin.saved": "充值地址已保存",

      "admin.checking": "正在验证…",
      "admin.noPerm": "权限不足",
      "admin.noPermShort": "需要管理员权限",
      "admin.return": "返回",
      "admin.title": "管理员面板 — HAI",
      "admin.adminPanel": "管理员面板",
      "admin.pinLayer": "第二安全层",
      "admin.pinPromptEnter": "输入附加密码以继续",
      "admin.pinPromptSetup": "创建附加密码（至少 4 位）以保护管理员面板",
      "admin.pinExtra": "附加密码",
      "admin.pinNew": "新密码",
      "admin.pinConfirm": "确认密码",
      "admin.pinOpen": "解锁面板",
      "admin.pinSaveActivate": "保存并启用",
      "admin.pinMin4": "至少 4 个字符",
      "admin.pinMismatch": "密码不一致",
      "admin.pinSet": "附加密码已设置",
      "admin.pinWrong": "密码错误",
      "admin.statPrice": "HAI 价格",
      "admin.statUsers": "用户数",
      "admin.statEvolutions": "演化周期",
      "admin.alertsTitle": "Webhook 警报 ({{count}})",
      "admin.openLog": "打开日志",
      "admin.markAllRead": "全部标为已读",
      "admin.usersMgmt": "用户管理",
      "admin.usersMgmtDesc": "封禁、角色、余额、删除",
      "admin.webhooksLog": "NOWPayments Webhooks 日志",
      "admin.webhooksLogDesc": "每笔交易状态：成功/失败/重复，含完整详情",
      "admin.auditLog": "操作审计日志",
      "admin.auditLogDesc": "所有余额修改、封禁、角色变更或删除，含执行者和时间",
      "admin.smartCoin": "自演化智能代币",
      "admin.smartCoinDesc": "运行 AI 演化周期 — 分析安全、市场与表现并自动调整 HAI 价格",
      "admin.evolveNow": "立即演化",
      "admin.thinking": "思考中…",
      "admin.evolved": "代币已演化 — 新价格 {{price}} USDT",
      "admin.evolutionLog": "智能演化日志",
      "admin.noCycles": "暂无周期",
      "admin.security": "安全",
      "admin.market": "市场",
      "admin.performance": "表现",

      "adminUsers.title": "用户管理",
      "adminUsers.searchPh": "按邮箱或姓名搜索…",
      "adminUsers.fAll": "全部 ({{count}})",
      "adminUsers.fAdmin": "管理员",
      "adminUsers.fUser": "普通用户",
      "adminUsers.fBanned": "已封禁",
      "adminUsers.empty": "没有用户",
      "adminUsers.banned": "已封禁",
      "adminUsers.balance": "余额",
      "adminUsers.role": "角色",
      "adminUsers.unban": "解封",
      "adminUsers.ban": "封禁",
      "adminUsers.banReasonPrompt": "封禁原因？",
      "adminUsers.banDone": "已封禁",
      "adminUsers.unbanDone": "已解封",
      "adminUsers.roleUpdated": "角色已更新",
      "adminUsers.adjustPrompt": "调整 {{email}} 的余额（正数为增加，负数为扣减）：",
      "adminUsers.balanceUpdated": "余额已更新",
      "adminUsers.deleteConfirm": "永久删除用户 {{email}}？此操作不可撤销。",
      "adminUsers.deleted": "已删除",
      "adminUsers.changeRoleOf": "更改 {{email}} 的角色",
      "adminUsers.reasonLabel": "原因",

      "audit.title": "管理员审计日志",
      "audit.empty": "暂无操作",
      "audit.actor": "执行者",
      "audit.target": "目标",
      "audit.actAdjust": "调整余额",
      "audit.actBan": "封禁用户",
      "audit.actUnban": "解封",
      "audit.actSetRole": "更改角色",
      "audit.actDelete": "删除用户",

      "wh.title": "NOWPayments Webhooks 日志",
      "wh.refresh": "刷新",
      "wh.statTotal": "总计",
      "wh.statOk": "成功",
      "wh.statFail": "失败",
      "wh.statDup": "重复",
      "wh.empty": "尚未收到 webhook。",
      "wh.sigOk": "签名有效",
      "wh.sigUnverified": "签名未验证",
      "wh.details": "详情",
      "wh.detailsTitle": "Webhook 详情",
      "wh.sReceived": "已接收",
      "wh.sProcessed": "已处理",
      "wh.sCredited": "已入账",
      "wh.sDuplicate": "重复",
      "wh.sIgnored": "已忽略",
      "wh.sInvalidSig": "签名无效",
      "wh.sError": "错误",
      "wh.sFailed": "失败",

      // Transfer
      "tr.title": "转账 HAI",
      "sup.title": "技术支持",
      "sup.adminTitle": "支持工单",
      "sup.adminDesc": "用户问题反馈",
      "sup.adminOnly": "仅限管理员",
      "sup.back": "返回",
      "sup.heroTitle": "直接联系管理员",
      "sup.heroSub": "发送您的问题，我们会尽快回复",
      "sup.category": "问题类型",
      "sup.subject": "主题",
      "sup.subjectPh": "简短描述",
      "sup.message": "详细描述",
      "sup.messagePh": "请详细描述问题…",
      "sup.send": "发送给管理员",
      "sup.sent": "工单已发送",
      "sup.subjectShort": "主题太短",
      "sup.messageShort": "消息太短",
      "sup.myTickets": "我的工单",
      "sup.empty": "暂无工单",
      "sup.adminReply": "管理员回复",
      "sup.filter": "筛选",
      "sup.all": "全部",
      "sup.replyPh": "输入您的回复…",
      "sup.replyShort": "回复太短",
      "sup.replied": "回复已发送",
      "sup.replyAndResolve": "回复并关闭",
      "sup.markInProgress": "处理中",
      "sup.close": "关闭",
      "sup.statusUpdated": "状态已更新",
      "sup.cat.account": "账户",
      "sup.cat.deposit": "充值",
      "sup.cat.transfer": "转账",
      "sup.cat.trade": "交易",
      "sup.cat.bug": "故障",
      "sup.cat.security": "安全",
      "sup.cat.other": "其他",
      "sup.status.open": "待处理",
      "sup.status.in_progress": "处理中",
      "sup.status.resolved": "已解决",
      "sup.status.closed": "已关闭",
      "tr.back": "返回",
      "tr.heroTitle": "向其他用户发送 HAI",
      "tr.heroSub": "由交易 PIN 保护 — 每日限额 2,000,000 HAI",
      "tr.available": "可用余额",
      "tr.dailyLimit": "每日转账限额",
      "tr.dailyUsed": "24小时内已用",
      "tr.dailyRemaining": "24小时内剩余",
      "tr.unlimited": "无限制（管理员）",
      "tr.myPayId": "您的充值 ID",
      "tr.stable": "永久不变",
      "tr.copyId": "复制 ID",
      "tr.scanToSend": "扫描二维码向您的钱包发送 HAI",
      "tr.shareDesc": "与平台上的任何用户分享此 ID 或二维码,他们便可直接将 HAI 发送到您的钱包。",
      "tr.needPin": "在转账之前必须设置交易 PIN。",
      "tr.goSettings": "前往设置",
      "tr.recipientLabel": "收款人（仅充值 ID — HAI-XXXXXXXX）",
      "tr.search": "搜索",
      "tr.scanQr": "扫描二维码",
      "tr.scanQrTitle": "扫描二维码",
      "tr.scanHint": "扫描充值 ID 二维码 — 转账前会显示一个验证步骤。",
      "tr.payIdMatch": "匹配:此 ID 完全属于该用户",
      "tr.payIdMismatch": "ID 与收款人不匹配 — 请在继续前核实",
      "tr.user": "用户",
      "tr.cantSelf": "您不能向自己转账",
      "tr.confirmCheck": "我已目视确认这是正确的收款人,并且此次转账是最终的且不可退还的。",
      "tr.amountLabel": "金额 (HAI)",
      "tr.all": "全部",
      "tr.pinLabel": "交易 PIN",
      "tr.sending": "正在转账…",
      "tr.sendNow": "立即发送",
      "tr.finalNote": "转账是最终的且不可逆。请在确认前核对收款人信息。",
      "tr.success": "转账成功 ✓",
      "tr.successAmount": "已成功转账 {{amount}} HAI",
      "tr.hideReceipt": "隐藏",
      "tr.amount": "金额",
      "tr.recipient": "收款人",
      "tr.txId": "交易号",
      "tr.toHome": "首页",
      "tr.newTransfer": "新转账",
      "tr.copied": "已复制",
      "tr.cameraUnsupported": "您的设备不支持访问相机",
      "tr.cameraDenied": "相机权限被拒绝。请在浏览器/手机设置中启用后重试。",
      "tr.cameraNotFound": "在此设备上未找到相机。",
      "tr.cameraFailed": "无法访问相机",
      "tr.notFound": "未找到用户。请核对 ID(例如 HAI-XXXXXXXX)、邮箱或用户名。",
      "tr.selfId": "这是您自己的 ID — 不能转账到自己的账户",
      "tr.invalidPay": "该代码不是有效的 HAI 充值 ID",
      "tr.notFoundPay": "未找到使用此 ID 的用户",
      "tr.payMismatchSec": "ID 不匹配 — 出于安全原因被拒绝",
      "tr.cantOpenCamera": "无法打开相机",
      "tr.confirmedRecipient": "已目视确认收款人 ✓",
      "tr.pickRecipient": "请先选择收款人",
      "tr.confirmFirst": "请在转账前目视确认收款人",
      "tr.invalidAmount": "请输入有效金额",
      "tr.lowBalance": "余额不足",
      "tr.enterPin": "请输入您的 PIN",
      "tr.permTitle": "相机权限",
      "tr.permDesc": "为了扫描充值 ID 二维码,应用需要访问您设备的相机。不会录制或上传任何图像 — 相机仅在浏览器本地用于读取二维码。",
      "tr.permWarn": "现在将出现浏览器/手机的官方提示。点击 <b>允许</b> 以继续。如果您之前已拒绝,请在站点设置中手动启用。",
      "tr.cancel": "取消",
      "tr.requesting": "正在请求…",
      "tr.allowCamera": "允许相机",
      "tr.scanQrHint": "将相机对准充值 ID 二维码 HAI-XXXXXXXX",
      "tr.verifyTitle": "验证收款人",
      "tr.verifyDesc": "已从二维码检测到充值 ID。请在继续前核对详细信息。",
      "tr.recipientName": "收款人姓名",
      "tr.amountToSend": "转账金额 (HAI)",
      "tr.currentBalance": "您的当前余额",
      "tr.amountSent": "发送金额",
      "tr.willReceive": "收款人将收到",
      "tr.expectedAfter": "转账后您的预期余额",
      "tr.lowBalanceShort": "此金额余额不足。",
      "tr.confirmRecipient": "确认收款人",
      "tr.hideReceiptAria": "隐藏收据",

      // Deposits
      "dep.title": "充值记录",
      "dep.history": "记录",
      "dep.back": "返回",
      "dep.heroTitle": "用 USDT 购买 HAI",
      "dep.heroSub": "安全支付 — 链上自动确认",
      "dep.linked": "已与您的账户绑定",
      "dep.amountUsdt": "USDT 金额",
      "dep.livePrice": "平台实时价格:1 HAI = {{price}} USDT (1 USDT = {{inv}} HAI)",
      "dep.fetchingPrice": "正在获取价格…",
      "dep.warnPrice": "⚠ 余额按支付确认时的实时 HAI 价格入账,可能与当前计算略有不同。",
      "dep.lockingPrice": "正在锁定价格…",
      "dep.relock": "重新锁定价格并创建新发票",
      "dep.lock": "锁定价格并创建支付发票",
      "dep.invoiceLine": "您的专属发票 #{{id}} — 下方二维码仅与您的账户绑定。",
      "dep.priceAtCalc": "计算时的价格",
      "dep.time": "时间",
      "dep.priceNow": "当前实时价格",
      "dep.expectedHai": "支付时预期 HAI",
      "dep.priceChanged": "价格变动 {{pct}}% — 与计算相比相差 {{diff}} HAI",
      "dep.sendExactly": "请精确发送",
      "dep.onNetwork": "仅在 <strong>{{net}} (BEP20)</strong> 网络上",
      "dep.qrAria": "支付地址二维码",
      "dep.payAddress": "支付地址",
      "dep.copyAmount": "复制所需金额",
      "dep.autoCredit": "网络确认后(通常 1–5 分钟)HAI 将自动入账。",
      "dep.noInvoice": "点击上方“锁定价格并打开支付工具”以生成与您的账户绑定的唯一支付发票。",
      "dep.notesTitle": "重要提示:",
      "dep.note1": "在上方工具中选择 <strong>BSC / BEP20</strong> 网络上的 <strong>USDT</strong>。",
      "dep.note2": "将所需金额精确地发送到显示的支付地址。",
      "dep.note3": "链上确认后 HAI 将自动添加到您的钱包。",
      "dep.loading": "加载中…",
      "dep.empty": "尚无充值。",
      "dep.via": "通过 {{cur}}",
      "dep.haiAdded": "已入账 HAI",
      "dep.pending": "(待处理)",
      "dep.amountRequired": "所需金额",
      "dep.opNumber": "操作 ID:{{id}}",
      "dep.invoiceCreated": "已创建发票 — 请将付款发送至下方显示的地址",
      "dep.invoiceFailed": "无法创建发票",
      "dep.invalidApi": "NOWPayments 密钥被拒绝。请使用来自 NOWPayments 账户的有效生产 API 密钥,而非沙盒密钥。",
      "dep.copied": "已复制",
      "dep.sWaiting": "等待付款",
      "dep.sConfirming": "确认中",
      "dep.sConfirmed": "已确认",
      "dep.sFinished": "已完成",
      "dep.sSending": "发送中",
      "dep.sPartial": "部分支付",
      "dep.sFailed": "失败",
      "dep.sRefunded": "已退款",
      "dep.sExpired": "已过期",

      // Deposit history
      "dh.title": "充值记录",
      "dh.back": "返回",
      "dh.pending": "待处理",
      "dh.success": "已完成",
      "dh.failed": "失败",
      "dh.viewAll": "显示所有充值",
      "dh.loading": "加载中…",
      "dh.empty": "暂无充值可显示。",
      "dh.lastUpdate": "最后更新",
      "dh.webhookEvents": "Webhook 事件 ({{count}})",
      "dh.noEvents": "尚未为此发票收到 webhook 事件。",
      "dh.status": "状态",
      "dh.signature": "签名",
      "dh.sigValid": "✓ 有效",
      "dh.sigInvalid": "✗ 无效",
      "dh.sPaid": "已支付",
      "dh.pReceived": "已接收",
      "dh.pCredited": "已入账",
      "dh.pIgnored": "中间状态",
      "dh.pDuplicate": "重复",
      "dh.pInvalidSig": "签名无效",
      "dh.pError": "错误",
      "dh.pFailed": "失败",

      // Deposit stages
      "stg.waiting": "等待付款",
      "stg.confirming": "链上确认中",
      "stg.sending": "正在向钱包入账 HAI",
      "stg.finished": "已完成",
      "stg.etaWaiting": "直到付款发送",
      "stg.etaConfirming": "≈ 1–5 分钟",
      "stg.etaSending": "≈ 几秒钟",
      "stg.exWaiting": "我们已创建发票,正在等待付款发送到 USDT (BSC) 地址。请精确发送支付工具中显示的金额。",
      "stg.exPartial": "仅收到部分金额。请发送剩余差额以确认付款。",
      "stg.exConfirming": "交易已在 BSC 网络上接收,正在等待所需的确认。通常 1–5 分钟。",
      "stg.exConfirmed": "交易已在链上确认。正在向您的钱包入账 HAI。",
      "stg.exSending": "正在向您的钱包添加 HAI — 即将完成。",
      "stg.exFinished": "充值成功完成,HAI 已添加到您的余额。",
      "stg.exPaid": "已收到并确认付款 — 充值完成。",
      "stg.exFailed": "操作失败。未扣除任何余额 — 您可以重试。",
      "stg.exRefunded": "金额已退还到您的发送钱包。",
      "stg.exExpired": "发票在收到付款前已过期。请创建新发票。",
      "stg.exUnknown": "未知状态。",
      "stg.failed": "充值失败",
      "stg.done": "充值已完成",
      "stg.processing": "处理中",
      "stg.lessMin": "不到一分钟",
      "stg.minShort": "分",
      "stg.hourShort": "小时",
      "stg.since": "{{t}}前",
      "stg.nextStage": "下一阶段 {{eta}}",
      "bp.dur5": "⚡5秒",
      "bp.dur10": "⚡10秒",
      "bp.dur30": "30秒",
      "bp.dur60": "1分",
      "bp.dur180": "3分",
      "bp.dur300": "5分",
      "bp.dur900": "15分",
      "bp.dur1800": "30分",
      "bp.dur3600": "1小时",
      "bp.win": "胜",
      "bp.loss": "负",
      "bp.draw": "平",
      "bp.tradeAmt": "交易 {{amt}} HAI · 总赔付 {{payout}} HAI",
      "bp.entryExit": "入场 {{entry}} → 出场 {{exit}}",
      "bp.refund": "平局 {{dir}} 退还 {{amt}} HAI",
      "bp.enterAmt": "请输入有效金额",
      "bp.enterPin": "请输入交易 PIN",
      "bp.cantOpen": "无法开仓",
      "bp.invalidPin": "PIN 错误",
      "bp.setPinFirst": "请先设置交易 PIN",
      "bp.lowBal": "余额不足以开仓",
      "bp.dailyLimit": "已超出每日交易限额 (100,000 HAI)",
      "bp.unsupDur": "不支持的持续时间",
      "bp.badDir": "无效方向",
      "bp.banned": "账户已被封禁",
      "bp.opened": "已开 {{dir}} 仓 {{amt}} HAI",
      "bp.up": "看涨 ▲",
      "bp.down": "看跌 ▼",
      "bp.pinLen": "PIN 必须为 4-12 位",
      "bp.pinMismatch": "PIN 不匹配",
      "bp.pinSet": "已设置交易 PIN",
      "bp.title": "交易 HAI · 涨/跌",
      "bp.soundOff": "关闭声音",
      "bp.soundOn": "开启声音",
      "bp.pinOn": "PIN 已启用",
      "bp.pinOff": "PIN 未设置",
      "bp.upLabel": "UP · 看涨",
      "bp.downLabel": "DOWN · 看跌",
      "bp.duration": "持续时间",
      "bp.amount": "金额 (HAI)",
      "bp.streak": "🔥 连胜:",
      "bp.best": "最佳: {{n}}",
      "bp.nextWin": "下次获胜 ×{{x}}",
      "bp.payRate": "胜率赔付:",
      "bp.totalWin": "获胜时总额:",
      "bp.onLoss": "失败时:",
      "bp.openTrade": "开 {{dir}} 仓",
      "bp.wins": "胜",
      "bp.losses": "负",
      "bp.winRate": "胜率",
      "bp.activeTrades": "活动交易 ({{n}})",
      "bp.secShort": "秒",
      "bp.lastResults": "最新结果",
      "bp.tie": "平",
      "bp.setPinTitle": "设置交易 PIN",
      "bp.confirmTrade": "确认交易",
      "bp.pinHint": "为保护您的账户,请设置交易 PIN(4-12 位),每次交易都会要求输入。",
      "bp.pinConfirmHint": "输入交易 PIN 以确认 <span class=\"{{cls}}\">{{dir}}</span> 仓 <span class=\"font-bold\">{{stake}} HAI</span>。",
      "bp.confirmPin": "确认 PIN",
      "bp.forgotPin": "忘记交易 PIN?立即重置",
      "bp.cancel": "取消",
      "bp.setOpen": "设置并开仓",
      "bp.confirm": "确认",
      "tm.enterQty": "请输入有效数量",
      "tm.orderPlacedSide": "已下 {{side}} 单",
      "tm.buy": "买",
      "tm.sell": "卖",
      "tm.cancelled": "订单已取消",
      "tm.title": "HAI 内部市场",
      "tm.high": "最高:",
      "tm.low": "最低:",
      "tm.impact24": "24小时影响",
      "tm.orders": "订单",
      "tm.yourBal": "您的余额",
      "tm.book": "订单簿",
      "tm.bid": "买 (Bid)",
      "tm.ask": "卖 (Ask)",
      "tm.noOrders": "无订单",
      "tm.bidPrice": "买价 (HAI)",
      "tm.askPrice": "卖价 (HAI)",
      "tm.market": "市场价",
      "tm.qty": "数量 (HAI)",
      "tm.available": "可用:",
      "tm.bidImpact": "买单影响:",
      "tm.askImpact": "卖单影响:",
      "tm.executing": "执行中...",
      "tm.buyHai": "购买 HAI",
      "tm.sellHai": "卖出 HAI",
      "tm.myOpen": "我的未结订单 ({{n}})",
      "ac.officialPrice": "官方价格 {{p}}",
      "ac.title": "HAI K线 · 官方价格 {{p}}",
      "ac.candles": "K线",
      "ac.line": "折线",
      "ac.area": "面积",
      "ac.zoomIn": "放大",
      "ac.zoomOut": "缩小",
      "ac.fit": "适应",
      "ac.taller": "加高",
      "ac.shorter": "降低",
      "ac.noData": "暂无足够的价格数据。",
      "ai.greet": "你好!我是 HAI 智能助手。请向我询问平台、交易或分析您的表现。",
      "ai.rate": "已超出限制,请稍后重试",
      "ai.noCredits": "助手额度已用完",
      "ai.connFail": "连接失败,请重试。",
      "ai.aria": "HAI 智能助手",
      "ai.title": "HAI 助手",
      "ai.sub": "由 AI 驱动",
      "ai.placeholder": "输入您的问题...",
      "ls.ar": "العربية",
      "fd.writeOrAttach": "请输入内容或附加媒体",
      "fd.unsupType": "不支持的文件类型",
      "fd.unsupExt": "不允许的扩展名",
      "fd.rejected": "帖子被拒绝: {{r}}",
      "fd.inappropriate": "不当内容",
      "fd.publishedPinned": "已发布并置顶",
      "fd.published": "已发布",
      "fd.confirmDelete": "删除帖子?",
      "fd.deleteFailed": "删除失败: {{m}}",
      "fd.deleted": "已删除",
      "fd.commentRejected": "评论被拒: {{r}}",
      "fd.unsupMedia": "不支持的类型。图片:JPG/PNG/WEBP/GIF — 视频:MP4/WEBM/MOV",
      "fd.maxSize": "最大 {{mb}}MB",
      "fd.placeholder": "你在想什么?",
      "fd.preview": "预览",
      "fd.image": "图片",
      "fd.video": "视频",
      "fd.posting": "发布中...",
      "fd.publish": "发布",
      "fd.dropHint": "可以拖放文件 · 最大:图片 10MB / 视频 50MB",
      "fd.all": "全部",
      "fd.country": "我的国家",
      "fd.following": "关注中",
      "fd.empty": "暂无帖子 — 来发第一条吧!",
      "fd.user": "用户",
      "fd.adminPin": "管理员帖",
      "fd.followed": "已关注",
      "fd.follow": "关注",
      "fd.dm": "私信",
      "fd.commentPh": "写评论…",
      "th.market_buy": "市价买",
      "th.market_sell_lock": "市价卖",
      "th.order_refund": "订单退款",
      "th.buy": "买",
      "th.sell": "卖",
      "th.ad_reward": "广告奖励",
      "th.reward": "奖励",
      "th.crypto_deposit": "USDT 充值",
      "th.admin_grant": "管理员发放",
      "th.admin_adjust": "管理员调整",
      "th.bonus": "奖金",
      "th.withdrawal": "提现",
      "th.deposit": "充值",
      "th.purchase": "购买",
      "th.sale": "出售",
      "th.transfer": "转账",
      "th.loadMore": "加载更多...",
      "th.endList": "— 列表结束 —",
      "th.title": "交易和钱包历史",
      "th.balance": "余额",
      "th.totalEarn": "总收益",
      "th.coinPower": "币强度: {{n}}",
      "th.fees": "手续费",
      "th.feesCount": "{{n}} 笔",
      "th.tabsOrders": "订单 ({{n}})",
      "th.tabsTrades": "交易 ({{n}})",
      "th.tabsFees": "手续费 ({{n}})",
      "th.noOrders": "无订单",
      "th.statusOpen": "未结",
      "th.statusFilled": "已成交",
      "th.statusCancelled": "已取消",
      "th.noTrades": "无交易",
      "th.noFees": "无手续费",
      "th.feeDefault": "手续费",
      "rf.registered": "推荐已记录",
      "rf.copied": "{{label}} 已复制 ✓",
      "rf.copyFail": "复制失败",
      "rf.shareText": "加入 HAI 获取代币!使用我的链接: {{link}}",
      "rf.text": "文本",
      "rf.loading": "加载中…",
      "rf.title": "邀请朋友赚奖励",
      "rf.perFriend": "每位加入的朋友 +10 HAI",
      "rf.invited": "已邀请",
      "rf.totalEarn": "总收益",
      "rf.code": "您的代码",
      "rf.linkLabel": "您的推荐链接",
      "rf.link": "链接",
      "rf.copyLink": "复制链接",
      "rf.share": "分享",
      "rf.askCode": "朋友邀请了您?输入他的代码(仅一次)",
      "rf.confirm": "确认",
      "rf.alreadyRegistered": "✓ 已使用推荐码注册",
      "rf.recent": "最新被邀请人",
      "rf.shareNote": "分享您的链接 — 每位加入的朋友立即为您加 10 HAI 🎁",
      "lq.base": "固定流动性基础",
      "lq.deposits": "代币购买充值 (USDT)",
      "lq.wallets": "用户余额",
      "lq.openBuy": "未结买单",
      "lq.bets24": "最近 24 小时投注",
      "lq.refRewards": "推荐奖励",
      "lq.totalSub": "平台总流动性",
      "lq.coinPrice": "代币价格 0.0100 USDT",
      "lq.sources": "流动性来源:",
      "lq.note": "每次 USDT 代币购买、每个新市场订单以及每次推荐奖励或未平投注都会自动增加流动性。",
      "pf.invalidSym": "无效符号: {{r}}",
      "pf.savedLocal": "本地偏好已保存 · {{s}}",
      "pf.savedAll": "价格设置已保存 · {{s}}",
      "pf.title": "实时价格源",
      "pf.connected": "已连接",
      "pf.disconnected": "未连接",
      "pf.source": "来源: Binance(免费,无需 API 密钥)",
      "pf.symLabel": "交易代码",
      "pf.willUse": "将使用: ",
      "pf.checking": "检查中…",
      "pf.valid": "有效 · ",
      "pf.examples": "示例: BTC、btc/usdt、eth-usdt、SOLUSDT… 自动转换。",
      "pf.enable": "启用价格源",
      "pf.enableHint": "关闭后,将停止向数据库写入价格。",
      "pf.saveAll": "保存设置(全局)",
      "pf.saveLocal": "保存本地偏好",
      "pf.adminOnly": "全局符号仅由管理员设置。您可以保存本地显示偏好。",
      "ct.last24": "最近 24 小时",
      "ct.last7": "最近 7 天",
      "ct.last30": "最近 30 天",
      "ct.title": "用 USDT 购买 HAI 按钮统计",
      "ct.loading": "加载中…",
      "ct.clicks": "点击 ({{l}})",
      "ct.unique": "独立用户",
      "ct.created": "已创建发票",
      "ct.paid": "已付发票",
      "ct.clickToInv": "点击 → 发票",
      "ct.clickToInvHint": "从点击到发票创建的转化率",
      "ct.invToPay": "发票 → 付款",
      "ct.invToPayHint": "已创建发票的付款完成率",
      "ct.totalClicks": "总点击数",
      "ct.totalClicksHint": "自跟踪开始",
      "ct.byHourDay": "CTR 和付款率(按 {{u}})",
      "ct.hour": "小时",
      "ct.day": "天",
      "ct.ctrLine": "CTR (点击→发票)",
      "ct.payRateLine": "付款率",
    },
  },
};

const saved = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
const initialLang = saved || (typeof navigator !== "undefined" && navigator.language.startsWith("zh") ? "zh" : navigator?.language?.startsWith("en") ? "en" : "ar");

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const setLang = (lang: string) => {
  i18n.changeLanguage(lang);
  localStorage.setItem("lang", lang);
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
};

if (typeof document !== "undefined") {
  document.documentElement.lang = initialLang;
  document.documentElement.dir = initialLang === "ar" ? "rtl" : "ltr";
}

export default i18n;
